var _slicedToArray = require("D:\\\u7814\u7A76\u751F\u5DE5\u4F5C\\\u91D1\u878D\u53EF\u89C6\u5316\\\u4EE3\u7801\\system\\DiffSeer\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("D:\\\u7814\u7A76\u751F\u5DE5\u4F5C\\\u91D1\u878D\u53EF\u89C6\u5316\\\u4EE3\u7801\\system\\DiffSeer\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("D:\\\u7814\u7A76\u751F\u5DE5\u4F5C\\\u91D1\u878D\u53EF\u89C6\u5316\\\u4EE3\u7801\\system\\DiffSeer\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\\u7814\u7A76\u751F\u5DE5\u4F5C\\\u91D1\u878D\u53EF\u89C6\u5316\\\u4EE3\u7801\\system\\DiffSeer\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).reorder = {});
}(this, function (t) {
  "use strict";

  function e(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    arguments.length < 2 && (e = t, t = 0);
    var r = [];
    var o = t;
    if (n < 0) for (; o > e; o += n) {
      r.push(o);
    } else for (; o < e; o += n) {
      r.push(o);
    }
    return r;
  }

  var n = e;

  function r(t, e) {
    var n = e ? Array(t.length) : {};

    for (var _e = 0; _e < t.length; _e++) {
      n[t[_e]] = _e;
    }

    return n;
  }

  function o(t, e, n, r) {
    var o = t.inEdges(e),
        l = t.inEdges(n);
    var i = 0;

    for (var _t2 = 0; _t2 < l.length; _t2++) {
      var _e2 = r[l[_t2].target.index];

      for (var _t3 = 0; _t3 < o.length; _t3++) {
        r[o[_t3].target.index] > _e2 && i++;
      }
    }

    return i;
  }

  function l(t, e, n, r) {
    var o = t.outEdges(e),
        l = t.outEdges(n);
    var i = 0;

    for (var _t4 = 0; _t4 < l.length; _t4++) {
      var _e3 = r[l[_t4].source.index];

      for (var _t5 = 0; _t5 < o.length; _t5++) {
        r[o[_t5].source.index] > _e3 && i++;
      }
    }

    return i;
  }

  function i(t, e) {
    return t - e;
  }

  function f(t) {
    return "function" == typeof t ? t : function () {
      return t;
    };
  }

  function s(t, e) {
    var n, r;
    (t = Math.abs(t)) > (e = Math.abs(e)) ? (n = t, r = e) : (n = e, r = t);
    var o = r / n;
    return n * Math.sqrt(1 + o * o);
  }

  function a(t) {
    var e = -1,
        n = [];
    if (1 === arguments.length) for (; ++e < t;) {
      n[e] = 0;
    } else for (; ++e < t;) {
      n[e] = a.apply(this, Array.prototype.slice.call(arguments, 1));
    }
    return n;
  }

  function c(t, e, n, r) {
    var o, l;
    return Math.abs(n) > Math.abs(r) ? [(t + (o = r / n) * e) / (l = n + o * r), (e - o * t) / l] : [((o = n / r) * t + e) / (l = r + o * n), (o * e - t) / l];
  }

  function u(t, e) {
    for (var n = 0, r = -1, o = Math.min(t.length, e.length); ++r < o;) {
      n += t[r] * e[r];
    }

    return n;
  }

  function h(t, e) {
    e || (e = 1e-10);

    for (var n, r, o = t.length, l = t[0].length, i = -1; ++i < o;) {
      var f = i;

      for (n = i; ++n < o;) {
        Math.abs(t[n][i]) > Math.abs(t[f][i]) && (f = n);
      }

      var s = t[i];
      if (t[i] = t[f], t[f] = s, Math.abs(t[i][i]) <= e) return !1;

      for (n = i; ++n < o;) {
        var a = t[n][i] / t[i][i];

        for (r = i - 1; ++r < l;) {
          t[n][r] -= t[i][r] * a;
        }
      }
    }

    for (i = o; --i >= 0;) {
      a = t[i][i];

      for (n = -1; ++n < i;) {
        for (r = l; --r >= i;) {
          t[n][r] -= t[i][r] * t[n][i] / a;
        }
      }

      for (t[i][i] /= a, r = o - 1; ++r < l;) {
        t[i][r] /= a;
      }
    }

    return !0;
  }

  function g(t) {
    return Math.sqrt(u(t, t));
  }

  var d = Object.freeze({
    cross: function cross(t, e) {
      return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
    },
    decompose: function decompose() {
      return function (t) {
        for (var e = t.length, n = [], r = [], o = [], l = 0; l < e; l++) {
          n[l] = [], r[l] = [], o[l] = [];
        }

        for (var i = !0, f = 0; f < e; f++) {
          for (l = 0; l < e; l++) {
            if (t[l][f] !== t[f][l]) {
              i = !1;
              break;
            }
          }
        }

        if (i) {
          for (l = 0; l < e; l++) {
            n[l] = t[l].slice();
          }

          !function (t, e, n) {
            for (var r = n.length, o = 0; o < r; o++) {
              t[o] = n[r - 1][o];
            }

            for (var l = r - 1; l > 0; l--) {
              for (var i = 0, f = 0, s = 0; s < l; s++) {
                i += Math.abs(t[s]);
              }

              if (0 === i) {
                e[l] = t[l - 1];

                for (o = 0; o < l; o++) {
                  t[o] = n[l - 1][o], n[l][o] = 0, n[o][l] = 0;
                }
              } else {
                for (s = 0; s < l; s++) {
                  t[s] /= i, f += t[s] * t[s];
                }

                var a = t[l - 1],
                    c = Math.sqrt(f);
                a > 0 && (c = -c), e[l] = i * c, f -= a * c, t[l - 1] = a - c;

                for (o = 0; o < l; o++) {
                  e[o] = 0;
                }

                for (o = 0; o < l; o++) {
                  a = t[o], n[o][l] = a, c = e[o] + n[o][o] * a;

                  for (s = o + 1; s <= l - 1; s++) {
                    c += n[s][o] * t[s], e[s] += n[s][o] * a;
                  }

                  e[o] = c;
                }

                a = 0;

                for (o = 0; o < l; o++) {
                  e[o] /= f, a += e[o] * t[o];
                }

                var u = a / (f + f);

                for (o = 0; o < l; o++) {
                  e[o] -= u * t[o];
                }

                for (o = 0; o < l; o++) {
                  a = t[o], c = e[o];

                  for (s = o; s <= l - 1; s++) {
                    n[s][o] -= a * e[s] + c * t[s];
                  }

                  t[o] = n[l - 1][o], n[l][o] = 0;
                }
              }

              t[l] = f;
            }

            for (l = 0; l < r - 1; l++) {
              if (n[r - 1][l] = n[l][l], n[l][l] = 1, 0 != (f = t[l + 1])) {
                for (s = 0; s <= l; s++) {
                  t[s] = n[s][l + 1] / f;
                }

                for (o = 0; o <= l; o++) {
                  for (c = 0, s = 0; s <= l; s++) {
                    c += n[s][l + 1] * n[s][o];
                  }

                  for (s = 0; s <= l; s++) {
                    n[s][o] -= c * t[s];
                  }
                }
              }

              for (s = 0; s <= l; s++) {
                n[s][l + 1] = 0;
              }
            }

            for (o = 0; o < r; o++) {
              t[o] = n[r - 1][o], n[r - 1][o] = 0;
            }

            n[r - 1][r - 1] = 1, e[0] = 0;
          }(r, o, n), function (t, e, n) {
            for (var r = n.length, o = 1; o < r; o++) {
              e[o - 1] = e[o];
            }

            e[r - 1] = 0;

            for (var l = 0, i = 0, f = 1e-12, a = 0; a < r; a++) {
              i = Math.max(i, Math.abs(t[a]) + Math.abs(e[a]));

              for (var c = a; c < r && !(Math.abs(e[c]) <= f * i);) {
                c++;
              }

              if (c > a) do {
                var u = t[a],
                    h = s(_ = (t[a + 1] - u) / (2 * e[a]), 1);
                _ < 0 && (h = -h), t[a] = e[a] / (_ + h), t[a + 1] = e[a] * (_ + h);
                var g = t[a + 1],
                    d = u - t[a];

                for (o = a + 2; o < r; o++) {
                  t[o] -= d;
                }

                l += d, _ = t[c];
                var p = 1,
                    m = p,
                    v = p,
                    M = e[a + 1],
                    b = 0,
                    x = 0;

                for (o = c - 1; o >= a; o--) {
                  v = m, m = p, x = b, u = p * e[o], d = p * _, h = s(_, e[o]), e[o + 1] = b * h, b = e[o] / h, _ = (p = _ / h) * t[o] - b * u, t[o + 1] = d + b * (p * u + b * t[o]);

                  for (var y = 0; y < r; y++) {
                    d = n[y][o + 1], n[y][o + 1] = b * n[y][o] + p * d, n[y][o] = p * n[y][o] - b * d;
                  }
                }

                _ = -b * x * v * M * e[a] / g, e[a] = b * _, t[a] = p * _;
              } while (Math.abs(e[a]) > f * i);
              t[a] = t[a] + l, e[a] = 0;
            }

            for (o = 0; o < r - 1; o++) {
              y = o;

              for (var _ = t[o], w = o + 1; w < r; w++) {
                t[w] < _ && (y = w, _ = t[w]);
              }

              if (y != o) {
                t[y] = t[o], t[o] = _;

                for (w = 0; w < r; w++) {
                  _ = n[w][o], n[w][o] = n[w][y], n[w][y] = _;
                }
              }
            }
          }(r, o, n);
        } else {
          var a = [];

          for (l = 0; l < e; l++) {
            a[l] = t[l].slice();
          }

          !function (t, e) {
            for (var n = t.length, r = [], o = 0, l = n - 1, i = o + 1; i < l; i++) {
              for (var f = 0, s = i; s <= l; s++) {
                f += Math.abs(t[s][i - 1]);
              }

              if (0 !== f) {
                var a = 0;

                for (s = l; s >= i; s--) {
                  r[s] = t[s][i - 1] / f, a += r[s] * r[s];
                }

                var c = Math.sqrt(a);
                r[i] > 0 && (c = -c), a -= r[i] * c, r[i] = r[i] - c;

                for (var u = i; u < n; u++) {
                  var h = 0;

                  for (s = l; s >= i; s--) {
                    h += r[s] * t[s][u];
                  }

                  h /= a;

                  for (s = i; s <= l; s++) {
                    t[s][u] -= h * r[s];
                  }
                }

                for (s = 0; s <= l; s++) {
                  for (h = 0, u = l; u >= i; u--) {
                    h += r[u] * t[s][u];
                  }

                  h /= a;

                  for (u = i; u <= l; u++) {
                    t[s][u] -= h * r[u];
                  }
                }

                r[i] = f * r[i], t[i][i - 1] = f * c;
              }
            }

            for (s = 0; s < n; s++) {
              for (u = 0; u < n; u++) {
                e[s][u] = s === u ? 1 : 0;
              }
            }

            for (i = l - 1; i >= o + 1; i--) {
              if (0 !== t[i][i - 1]) {
                for (s = i + 1; s <= l; s++) {
                  r[s] = t[s][i - 1];
                }

                for (u = i; u <= l; u++) {
                  for (c = 0, s = i; s <= l; s++) {
                    c += r[s] * e[s][u];
                  }

                  c = c / r[i] / t[i][i - 1];

                  for (s = i; s <= l; s++) {
                    e[s][u] += c * r[s];
                  }
                }
              }
            }
          }(a, n), function (t, e, n, r) {
            for (var o, l, i, f, s = n.length, a = s - 1, u = 0, h = s - 1, g = 1e-12, d = 0, p = 0, m = 0, v = 0, M = 0, b = 0, x = 0, y = 0; y < s; y++) {
              (y < u || y > h) && (t[y] = n[y][y], e[y] = 0);

              for (var _ = Math.max(y - 1, 0); _ < s; _++) {
                x += Math.abs(n[y][_]);
              }
            }

            var w = 0;

            for (; a >= u;) {
              for (var k = a; k > u && (0 === (M = Math.abs(n[k - 1][k - 1]) + Math.abs(n[k][k])) && (M = x), !(Math.abs(n[k][k - 1]) < g * M));) {
                k--;
              }

              if (k === a) n[a][a] = n[a][a] + d, t[a] = n[a][a], e[a] = 0, a--, w = 0;else if (k === a - 1) {
                if (l = n[a][a - 1] * n[a - 1][a], m = (p = (n[a - 1][a - 1] - n[a][a]) / 2) * p + l, b = Math.sqrt(Math.abs(m)), n[a][a] = n[a][a] + d, n[a - 1][a - 1] = n[a - 1][a - 1] + d, i = n[a][a], m >= 0) {
                  b = p + (p >= 0 ? b : -b), t[a - 1] = i + b, t[a] = t[a - 1], 0 !== b && (t[a] = i - l / b), e[a - 1] = 0, e[a] = 0, p = (i = n[a][a - 1]) / (M = Math.abs(i) + Math.abs(b)), m = b / M, p /= v = Math.sqrt(p * p + m * m), m /= v;

                  for (_ = a - 1; _ < s; _++) {
                    b = n[a - 1][_], n[a - 1][_] = m * b + p * n[a][_], n[a][_] = m * n[a][_] - p * b;
                  }

                  for (y = 0; y <= a; y++) {
                    b = n[y][a - 1], n[y][a - 1] = m * b + p * n[y][a], n[y][a] = m * n[y][a] - p * b;
                  }

                  for (y = u; y <= h; y++) {
                    b = r[y][a - 1], r[y][a - 1] = m * b + p * r[y][a], r[y][a] = m * r[y][a] - p * b;
                  }
                } else t[a - 1] = i + p, t[a] = i + p, e[a - 1] = b, e[a] = -b;

                a -= 2, w = 0;
              } else {
                if (i = n[a][a], f = 0, l = 0, k < a && (f = n[a - 1][a - 1], l = n[a][a - 1] * n[a - 1][a]), 10 == w) {
                  d += i;

                  for (y = u; y <= a; y++) {
                    n[y][y] -= i;
                  }

                  i = f = .75 * (M = Math.abs(n[a][a - 1]) + Math.abs(n[a - 1][a - 2])), l = -.4375 * M * M;
                }

                if (30 == w && (M = (M = (f - i) / 2) * M + l) > 0) {
                  M = Math.sqrt(M), f < i && (M = -M), M = i - l / ((f - i) / 2 + M);

                  for (y = u; y <= a; y++) {
                    n[y][y] -= M;
                  }

                  d += M, i = f = l = .964;
                }

                w++;

                for (var A = a - 2; A >= k && (p = ((v = i - (b = n[A][A])) * (M = f - b) - l) / n[A + 1][A] + n[A][A + 1], m = n[A + 1][A + 1] - b - v - M, v = n[A + 2][A + 1], p /= M = Math.abs(p) + Math.abs(m) + Math.abs(v), m /= M, v /= M, A != k) && !(Math.abs(n[A][A - 1]) * (Math.abs(m) + Math.abs(v)) < g * (Math.abs(p) * (Math.abs(n[A - 1][A - 1]) + Math.abs(b) + Math.abs(n[A + 1][A + 1]))));) {
                  A--;
                }

                for (y = A + 2; y <= a; y++) {
                  n[y][y - 2] = 0, y > A + 2 && (n[y][y - 3] = 0);
                }

                for (var $ = A; $ <= a - 1; $++) {
                  var q = $ != a - 1;
                  if ($ != A && (p = n[$][$ - 1], m = n[$ + 1][$ - 1], v = q ? n[$ + 2][$ - 1] : 0, 0 != (i = Math.abs(p) + Math.abs(m) + Math.abs(v)) && (p /= i, m /= i, v /= i)), 0 == i) break;

                  if (M = Math.sqrt(p * p + m * m + v * v), p < 0 && (M = -M), 0 != M) {
                    $ != A ? n[$][$ - 1] = -M * i : k != A && (n[$][$ - 1] = -n[$][$ - 1]), i = (p += M) / M, f = m / M, b = v / M, m /= p, v /= p;

                    for (_ = $; _ < s; _++) {
                      p = n[$][_] + m * n[$ + 1][_], q && (p += v * n[$ + 2][_], n[$ + 2][_] = n[$ + 2][_] - p * b), n[$][_] = n[$][_] - p * i, n[$ + 1][_] = n[$ + 1][_] - p * f;
                    }

                    for (y = 0; y <= Math.min(a, $ + 3); y++) {
                      p = i * n[y][$] + f * n[y][$ + 1], q && (p += b * n[y][$ + 2], n[y][$ + 2] = n[y][$ + 2] - p * v), n[y][$] = n[y][$] - p, n[y][$ + 1] = n[y][$ + 1] - p * m;
                    }

                    for (y = u; y <= h; y++) {
                      p = i * r[y][$] + f * r[y][$ + 1], q && (p += b * r[y][$ + 2], r[y][$ + 2] = r[y][$ + 2] - p * v), r[y][$] = r[y][$] - p, r[y][$ + 1] = r[y][$ + 1] - p * m;
                    }
                  }
                }
              }
            }

            if (0 == x) return;

            for (a = s - 1; a >= 0; a--) {
              if (p = t[a], 0 == (m = e[a])) {
                k = a;
                n[a][a] = 1;

                for (y = a - 1; y >= 0; y--) {
                  l = n[y][y] - p, v = 0;

                  for (_ = k; _ <= a; _++) {
                    v += n[y][_] * n[_][a];
                  }

                  if (e[y] < 0) b = l, M = v;else if (k = y, 0 === e[y] ? n[y][a] = -v / (0 !== l ? l : g * x) : (i = n[y][y + 1], f = n[y + 1][y], o = (i * M - b * v) / (m = (t[y] - p) * (t[y] - p) + e[y] * e[y]), n[y][a] = o, Math.abs(i) > Math.abs(b) ? n[y + 1][a] = (-v - l * o) / i : n[y + 1][a] = (-M - f * o) / b), g * (o = Math.abs(n[y][a])) * o > 1) for (_ = y; _ <= a; _++) {
                    n[_][a] = n[_][a] / o;
                  }
                }
              } else if (m < 0) {
                k = a - 1;
                if (Math.abs(n[a][a - 1]) > Math.abs(n[a - 1][a])) n[a - 1][a - 1] = m / n[a][a - 1], n[a - 1][a] = -(n[a][a] - p) / n[a][a - 1];else {
                  var N = c(0, -n[a - 1][a], n[a - 1][a - 1] - p, m);
                  n[a - 1][a - 1] = N[0], n[a - 1][a] = N[1];
                }
                n[a][a - 1] = 0, n[a][a] = 1;

                for (y = a - 2; y >= 0; y--) {
                  var z,
                      E,
                      I = 0,
                      j = 0;

                  for (_ = k; _ <= a; _++) {
                    I += n[y][_] * n[_][a - 1], j += n[y][_] * n[_][a];
                  }

                  if (l = n[y][y] - p, e[y] < 0) b = l, v = I, M = j;else {
                    if (k = y, 0 == e[y]) {
                      N = c(-I, -j, l, m);
                      n[y][a - 1] = N[0], n[y][a] = N[1];
                    } else {
                      i = n[y][y + 1], f = n[y + 1][y], 0 == (z = (t[y] - p) * (t[y] - p) + e[y] * e[y] - m * m) & 0 == (E = 2 * (t[y] - p) * m) && (z = g * x * (Math.abs(l) + Math.abs(m) + Math.abs(i) + Math.abs(f) + Math.abs(b)));
                      N = c(i * v - b * I + m * j, i * M - b * j - m * I, z, E);
                      if (n[y][a - 1] = N[0], n[y][a] = N[1], Math.abs(i) > Math.abs(b) + Math.abs(m)) n[y + 1][a - 1] = (-I - l * n[y][a - 1] + m * n[y][a]) / i, n[y + 1][a] = (-j - l * n[y][a] - m * n[y][a - 1]) / i;else {
                        N = c(-v - f * n[y][a - 1], -M - f * n[y][a], b, m);
                        n[y + 1][a - 1] = N[0], n[y + 1][a] = N[1];
                      }
                    }

                    if (g * (o = Math.max(Math.abs(n[y][a - 1]), Math.abs(n[y][a]))) * o > 1) for (_ = y; _ <= a; _++) {
                      n[_][a - 1] = n[_][a - 1] / o, n[_][a] = n[_][a] / o;
                    }
                  }
                }
              }
            }

            for (y = 0; y < s; y++) {
              if (y < u || y > h) for (_ = y; _ < s; _++) {
                r[y][_] = n[y][_];
              }
            }

            for (_ = s - 1; _ >= u; _--) {
              for (y = u; y <= h; y++) {
                b = 0;

                for ($ = u; $ <= Math.min(_, h); $++) {
                  b += r[y][$] * n[$][_];
                }

                r[y][_] = b;
              }
            }
          }(r, o, a, n);
        }

        var u = [];

        for (l = 0; l < e; l++) {
          var h = u[l] = [];

          for (f = 0; f < e; f++) {
            h[f] = l === f ? r[l] : 0;
          }

          u[l][o[l] > 0 ? l + 1 : l - 1] = o[l];
        }

        return {
          D: u,
          V: n
        };
      };
    },
    determinant: function determinant(t) {
      var e = t[0].concat(t[1]).concat(t[2]).concat(t[3]);
      return e[12] * e[9] * e[6] * e[3] - e[8] * e[13] * e[6] * e[3] - e[12] * e[5] * e[10] * e[3] + e[4] * e[13] * e[10] * e[3] + e[8] * e[5] * e[14] * e[3] - e[4] * e[9] * e[14] * e[3] - e[12] * e[9] * e[2] * e[7] + e[8] * e[13] * e[2] * e[7] + e[12] * e[1] * e[10] * e[7] - e[0] * e[13] * e[10] * e[7] - e[8] * e[1] * e[14] * e[7] + e[0] * e[9] * e[14] * e[7] + e[12] * e[5] * e[2] * e[11] - e[4] * e[13] * e[2] * e[11] - e[12] * e[1] * e[6] * e[11] + e[0] * e[13] * e[6] * e[11] + e[4] * e[1] * e[14] * e[11] - e[0] * e[5] * e[14] * e[11] - e[8] * e[5] * e[2] * e[15] + e[4] * e[9] * e[2] * e[15] + e[8] * e[1] * e[6] * e[15] - e[0] * e[9] * e[6] * e[15] - e[4] * e[1] * e[10] * e[15] + e[0] * e[5] * e[10] * e[15];
    },
    dot: u,
    gaussjordan: h,
    inverse: function inverse(t) {
      var e = t.length,
          n = -1;

      if (e === t[0].length) {
        for (h(t = t.map(function (t, n) {
          for (var r = new Array(e), o = -1; ++o < e;) {
            r[o] = n === o ? 1 : 0;
          }

          return t.concat(r);
        })); ++n < e;) {
          t[n] = t[n].slice(e);
        }

        return t;
      }
    },
    length: g,
    multiply: function multiply(t, e) {
      var n,
          r,
          o = t.length,
          l = e[0].length,
          i = e.length,
          f = -1;
      if (i !== t[0].length) throw {
        error: "columns(a) != rows(b); " + t[0].length + " != " + i
      };

      for (var s = new Array(o); ++f < o;) {
        for (s[f] = new Array(l), n = -1; ++n < l;) {
          var a = 0;

          for (r = -1; ++r < i;) {
            a += t[f][r] * e[r][n];
          }

          s[f][n] = a;
        }
      }

      return s;
    },
    normalize: function normalize(t) {
      var e = g(t);
      return t.map(function (t) {
        return t / e;
      });
    },
    transpose: function transpose(t) {
      for (var e, n = t.length, r = t[0].length, o = -1, l = new Array(r); ++o < r;) {
        for (l[o] = new Array(n), e = -1; ++e < n;) {
          l[o][e] = t[e][o];
        }
      }

      return l;
    },
    tridag: function tridag(t, e, n, r, o, l) {
      var i, f;

      for (i = 1; i < l; i++) {
        f = t[i] / e[i - 1], e[i] -= f * n[i - 1], r[i] -= f * r[i - 1];
      }

      for (o[l - 1] = r[l - 1] / e[l - 1], i = l - 2; i >= 0; i--) {
        o[i] = (r[i] - n[i] * o[i + 1]) / e[i];
      }
    }
  });

  function p(t) {
    var e = t < 0 ? -1 : 1;
    t < 0 && (e = -1, t = -t);
    var n = 1 / (1 + .3275911 * t);
    return e * (1 - ((((1.061405429 * n - 1.453152027) * n + 1.421413741) * n - .284496736) * n + .254829592) * n * Math.exp(-t * t));
  }

  var m = 1 / Math.sqrt(2 * Math.PI),
      v = Object.freeze({
    gaussian: function gaussian() {
      var t = Math.random,
          e = 0,
          n = 1,
          r = 1;

      function o() {
        var r, o, l;

        do {
          l = (r = 2 * t() - 1) * r + (o = 2 * t() - 1) * o;
        } while (l >= 1 || 0 === l);

        return e + n * r * Math.sqrt(-2 * Math.log(l) / l);
      }

      return o.pdf = function (t) {
        return t = (t - e) / n, m * Math.exp(-.5 * t * t) / n;
      }, o.cdf = function (t) {
        return .5 * (1 + p((t = (t - e) / n) / Math.SQRT2));
      }, o.mean = function (t) {
        return arguments.length ? (e = +t, o) : e;
      }, o.variance = function (t) {
        return arguments.length ? (n = Math.sqrt(r = +t), o) : r;
      }, o.random = function (e) {
        return arguments.length ? (t = e, o) : t;
      }, o;
    }
  });

  function M(t) {
    var e = t.length;
    if (0 === e) return NaN;

    for (var n = 0, r = -1; ++r < e;) {
      n += (t[r] - n) / (r + 1);
    }

    return n;
  }

  function b(t) {
    var e = t.length;
    if (e < 1) return NaN;
    if (1 === e) return 0;

    for (var n = M(t), r = -1, o = 0; ++r < e;) {
      var l = t[r] - n;
      o += l * l;
    }

    return o / (e - 1);
  }

  function x(t, e) {
    var n = (t = t.slice().sort(i)).length - 1;
    return e.map(function (e) {
      if (0 === e) return t[0];
      if (1 === e) return t[n];
      var r = 1 + e * n,
          o = Math.floor(r),
          l = r - o,
          i = t[o - 1];
      return 0 === l ? i : i + l * (t[o] - i);
    });
  }

  function y(t) {
    var e = x(t, [.25, .75]);
    return e[1] - e[0];
  }

  function _(t) {
    var e = y(t) / 1.34;
    return 1.06 * Math.min(Math.sqrt(b(t)), e) * Math.pow(t.length, -.2);
  }

  var w = Object.freeze({
    nrd0: function nrd0(t) {
      var e,
          n = Math.sqrt(b(t));
      return (e = Math.min(n, y(t) / 1.34)) || (e = n) || (e = Math.abs(t[1])) || (e = 1), .9 * e * Math.pow(t.length, -.2);
    },
    nrd: _
  });

  function k(t, e) {
    for (var n, r = t.length, o = -1, l = 0; ++o < r;) {
      l += (n = t[o] - e[o]) * n;
    }

    return Math.sqrt(l);
  }

  function A(t, e, n, r) {
    for (var o = [], l = t + n, i = e.length, f = -1; ++f < i;) {
      o[f] = (t * e[f] + n * r[f]) / l;
    }

    return o;
  }

  function $(t) {
    return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-.5 * t * t);
  }

  function q(t, e) {
    if (!t || !e || t.length !== e.length) return !1;

    for (var n = t.length, r = -1; ++r < n;) {
      if (t[r] !== e[r]) return !1;
    }

    return !0;
  }

  function N(t) {
    return x(t, [.5])[0];
  }

  function z(t) {
    for (var e = t.length, n = -1; ++n < e;) {
      if (!isFinite(t[n])) return !1;
    }

    return !0;
  }

  function E(t) {
    for (var e = t.length, n = 0; ++n < e;) {
      if (t[n - 1] >= t[n]) return !1;
    }

    return !0;
  }

  function I(t) {
    return (t = 1 - t * t * t) * t * t;
  }

  function j(t, e, n, r) {
    var o = r[0],
        l = O(e, r[1]);

    if (l < t.length && t[l] - t[n] < t[n] - t[o]) {
      var i = O(e, o);
      r[0] = i, r[1] = l;
    }
  }

  function O(t, e) {
    for (var n = e + 1; n < t.length && 0 === t[n];) {
      n++;
    }

    return n;
  }

  var D = Object.freeze({
    euclidean: k,
    manhattan: function manhattan(t, e) {
      for (var n = t.length, r = -1, o = 0; ++r < n;) {
        o += Math.abs(t[r] - e[r]);
      }

      return o;
    },
    minkowski: function minkowski(t) {
      return function (e, n) {
        for (var r = e.length, o = -1, l = 0; ++o < r;) {
          l += Math.pow(Math.abs(e[o] - n[o]), t);
        }

        return Math.pow(l, 1 / t);
      };
    },
    chebyshev: function chebyshev(t, e) {
      for (var n, r = t.length, o = -1, l = 0; ++o < r;) {
        (n = Math.abs(t[o] - e[o])) > l && (l = n);
      }

      return l;
    },
    hamming: function hamming(t, e) {
      for (var n = t.length, r = -1, o = 0; ++r < n;) {
        t[r] !== e[r] && o++;
      }

      return o;
    },
    jaccard: function jaccard(t, e) {
      for (var n = t.length, r = -1, o = 0; ++r < n;) {
        t[r] === e[r] && o++;
      }

      return o / n;
    },
    braycurtis: function braycurtis(t, e) {
      for (var n, r, o = t.length, l = -1, i = 0, f = 0; ++l < o;) {
        n = t[l], r = e[l], i += Math.abs(n - r), f += Math.abs(n + r);
      }

      return i / f;
    }
  }),
      P = Object.freeze({
    uniform: function uniform(t) {
      return t <= 1 && t >= -1 ? .5 : 0;
    },
    triangular: function triangular(t) {
      return t <= 1 && t >= -1 ? 1 - Math.abs(t) : 0;
    },
    epanechnikov: function epanechnikov(t) {
      return t <= 1 && t >= -1 ? .75 * (1 - t * t) : 0;
    },
    quartic: function quartic(t) {
      if (t <= 1 && t >= -1) {
        var e = 1 - t * t;
        return 15 / 16 * e * e;
      }

      return 0;
    },
    triweight: function triweight(t) {
      if (t <= 1 && t >= -1) {
        var e = 1 - t * t;
        return 35 / 32 * e * e * e;
      }

      return 0;
    },
    gaussian: $,
    cosine: function cosine(t) {
      return t <= 1 && t >= -1 ? Math.PI / 4 * Math.cos(Math.PI / 2 * t) : 0;
    }
  }),
      T = v,
      F = w,
      R = d,
      S = Object.freeze({
    distance: D,
    kernel: P,
    distribution: T,
    bandwidth: F,
    erf: p,
    hcluster: function hcluster() {
      var t = k;

      function e(e) {
        var n,
            r,
            o,
            l,
            i,
            f,
            s,
            a,
            c = e.length,
            u = [],
            h = [],
            g = [],
            d = [];

        for (s = -1; ++s < c;) {
          for (u[s] = 0, g[s] = [], a = -1; ++a < c;) {
            g[s][a] = s === a ? 1 / 0 : t(e[s], e[a]), g[s][u[s]] > g[s][a] && (u[s] = a);
          }
        }

        for (s = -1; ++s < c;) {
          d[s] = [], d[s][0] = {
            left: null,
            right: null,
            dist: 0,
            centroid: e[s],
            size: 1,
            depth: 0
          }, h[s] = 1;
        }

        for (i = 0; i < c - 1; i++) {
          for (n = 0, s = 0; s < c; s++) {
            g[s][u[s]] < g[n][u[n]] && (n = s);
          }

          r = u[n];
          var p = {
            left: o = d[n][0],
            right: l = d[r][0],
            dist: g[n][r],
            centroid: A(o.size, o.centroid, l.size, l.centroid),
            size: o.size + l.size,
            depth: 1 + Math.max(o.depth, l.depth)
          };

          for (d[n].splice(0, 0, p), h[n] += h[r], a = 0; a < c; a++) {
            g[n][a] > g[r][a] && (g[a][n] = g[n][a] = g[r][a]);
          }

          for (g[n][n] = 1 / 0, s = 0; s < c; s++) {
            g[s][r] = g[r][s] = 1 / 0;
          }

          for (a = 0; a < c; a++) {
            u[a] == r && (u[a] = n), g[n][a] < g[n][u[n]] && (u[n] = a);
          }

          f = p;
        }

        return f;
      }

      return e.distance = function (n) {
        return arguments.length ? (t = n, e) : t;
      }, e;
    },
    iqr: y,
    kde: function kde() {
      var t = $,
          e = [],
          n = _;

      function r(r, o) {
        var l = n.call(this, e);
        return r.map(function (n) {
          for (var r = -1, o = 0, i = e.length; ++r < i;) {
            o += t((n - e[r]) / l);
          }

          return [n, o / l / i];
        });
      }

      return r.kernel = function (e) {
        return arguments.length ? (t = e, r) : t;
      }, r.sample = function (t) {
        return arguments.length ? (e = t, r) : e;
      }, r.bandwidth = function (t) {
        return arguments.length ? (n = f(t), r) : n;
      }, r;
    },
    kmeans: function kmeans() {
      var t = k,
          e = 1;

      function n(n) {
        for (var r, o, l, i, f, s, a, c = n.length, u = [], h = [], g = 1, d = 0, p = function (t, e) {
          var n = e.length;
          if (t > n) return null;
          var r,
              o,
              l,
              i = [],
              f = [],
              s = {},
              a = 0,
              c = 0;

          for (; c < t;) {
            if (a === n) return null;
            var u = Math.floor(Math.random() * n);

            if (!(u in s)) {
              for (s[u] = 1, a++, o = e[u], l = !0, r = 0; r < c; r++) {
                if (q(o, i[r])) {
                  l = !1;
                  break;
                }
              }

              l && (i[c] = o, f[c] = u, c++);
            }
          }

          return i;
        }(e, n); g && d < 1e3;) {
          for (l = -1; ++l < e;) {
            h[l] = 0;
          }

          for (o = -1; ++o < c;) {
            for (i = n[o], s = 1 / 0, l = -1; ++l < e;) {
              (f = t.call(this, p[l], i)) < s && (s = f, a = l);
            }

            h[u[o] = a]++;
          }

          for (r = [], o = -1; ++o < c;) {
            if (null == (f = r[i = u[o]])) r[i] = n[o].slice();else for (l = -1; ++l < f.length;) {
              f[l] += n[o][l];
            }
          }

          for (l = -1; ++l < e;) {
            for (i = r[l], f = 1 / h[l], o = -1; ++o < i.length;) {
              i[o] *= f;
            }
          }

          for (g = 0, l = -1; ++l < e;) {
            if (!q(r[l], p[l])) {
              g = 1;
              break;
            }
          }

          p = r, d++;
        }

        return {
          assignments: u,
          centroids: p
        };
      }

      return n.k = function (t) {
        return arguments.length ? (e = t, n) : e;
      }, n.distance = function (e) {
        return arguments.length ? (t = e, n) : t;
      }, n;
    },
    loess: function loess() {
      var t = .3,
          e = 2,
          n = 1e-12;

      function r(r, o, l) {
        var i,
            f = r.length;
        if (f !== o.length) throw {
          error: "Mismatched array lengths"
        };
        if (0 == f) throw {
          error: "At least one point required."
        };
        if (arguments.length < 3) for (l = [], i = -1; ++i < f;) {
          l[i] = 1;
        }
        if (z(r), z(o), z(l), E(r), 1 == f) return [o[0]];
        if (2 == f) return [o[0], o[1]];
        var s = Math.floor(t * f);
        if (s < 2) throw {
          error: "Bandwidth too small."
        };
        var a = [],
            c = [],
            u = [];

        for (i = -1; ++i < f;) {
          a[i] = 0, c[i] = 0, u[i] = 1;
        }

        for (var h = -1; ++h <= e;) {
          var g,
              d = [0, s - 1];

          for (i = -1; ++i < f;) {
            g = r[i], i > 0 && j(r, l, i, d);

            for (var p = d[0], m = d[1], v = r[i] - r[p] > r[m] - r[i] ? p : m, M = 0, b = 0, x = 0, y = 0, _ = 0, w = Math.abs(1 / (r[v] - g)), k = p; k <= m; ++k) {
              var A = r[k],
                  $ = o[k],
                  q = k < i ? g - A : A - g,
                  O = A * (Q = I(q * w) * u[k] * l[k]);
              M += Q, b += O, x += A * O, y += $ * Q, _ += $ * O;
            }

            var D = b / M,
                P = y / M,
                T = _ / M,
                F = x / M,
                R = Math.sqrt(Math.abs(F - D * D)) < n ? 0 : (T - D * P) / (F - D * D),
                S = P - R * D;
            a[i] = R * g + S, c[i] = Math.abs(o[i] - a[i]);
          }

          if (h === e) break;
          var B,
              Q,
              V = N(c);
          if (Math.abs(V) < n) break;

          for (i = -1; ++i < f;) {
            B = c[i] / (6 * V), u[i] = B >= 1 ? 0 : (Q = 1 - B * B) * Q;
          }
        }

        return a;
      }

      return r.bandwidth = function (e) {
        return arguments.length ? (t = e, r) : e;
      }, r.robustnessIterations = function (t) {
        return arguments.length ? (e = t, r) : t;
      }, r.accuracy = function (t) {
        return arguments.length ? (n = t, r) : t;
      }, r;
    },
    mean: M,
    median: N,
    mode: function mode(t) {
      for (var e, n, r = {}, o = [], l = 0, i = t.length, f = -1; ++f < i;) {
        (n = r.hasOwnProperty(e = t[f]) ? ++r[e] : r[e] = 1) === l ? o.push(e) : n > l && (l = n, o = [e]);
      }

      if (1 === o.length) return o[0];
    },
    phi: function phi(t) {
      return .5 * (1 + p(t / Math.SQRT2));
    },
    quantiles: x,
    variance: b
  });
  var B = R.dot,
      Q = R.length,
      V = R.normalize,
      G = R.transpose,
      L = S.mean;

  function Y(t, e) {
    return t - e;
  }

  var C = Y;

  function H(t, e) {
    return t.concat(e);
  }

  function J(t) {
    var e = -1;
    var n = [];
    if (1 === arguments.length) for (; ++e < t;) {
      n[e] = 1 / 0;
    } else for (; ++e < t;) {
      n[e] = J.apply(this, Array.prototype.slice.call(arguments, 1));
    }
    return n;
  }

  function K(t, e) {
    var n = -1;
    var r = Array(t);

    for (; ++n < t;) {
      r[n] = e;
    }

    return r;
  }

  function U(t, e) {
    var n = [];
    e || (e = t.components());

    for (var _r = 0; _r < e.length; _r++) {
      n.push(W(t, e[_r]));
    }

    return n;
  }

  function W(t, e) {
    var n = J(e.length, e.length),
        o = r(e);

    for (var _t6 = 0; _t6 < e.length; _t6++) {
      n[_t6][_t6] = 0;
    }

    var l = function l(e) {
      if (e.source == e.target) return;
      if (!(e.source.index in o) || !(e.target.index in o)) return;
      var r = o[e.source.index],
          l = o[e.target.index];
      n[l][r] = n[r][l] = t.distance(e.index);
    };

    for (var _n = 0; _n < e.length; _n++) {
      t.edges(e[_n]).forEach(l);
    }

    for (var _t7 = 0; _t7 < e.length; _t7++) {
      for (var _r2 = 0; _r2 < e.length; _r2++) {
        if (n[_r2][_t7] != 1 / 0) for (var _o = 0; _o < e.length; _o++) {
          n[_t7][_o] != 1 / 0 && n[_r2][_o] > n[_r2][_t7] + n[_t7][_o] && (n[_r2][_o] = n[_r2][_t7] + n[_t7][_o], n[_o][_r2] = n[_r2][_o]);
        }
      }
    }

    return n;
  }

  function X(t, e, o) {
    var l = n(t.nodes().length);
    void 0 === e && (e = l.filter(function (e) {
      return 0 !== t.outDegree(e);
    }), o = l.filter(function (e) {
      return 0 !== t.inDegree(e);
    }));
    var i = !1;

    if (e.length < o.length) {
      var _t8 = e;
      e = o, o = _t8, i = !0;
    }

    var f = r(o);
    var s = [];

    for (var _n2 = 0; _n2 < e.length; _n2++) {
      var _r3 = i ? t.inEdges(e[_n2]).map(function (t) {
        return f[t.target.index];
      }) : t.outEdges(e[_n2]).map(function (t) {
        return f[t.source.index];
      });

      _r3.sort(C), s = s.concat(_r3);
    }

    var c = 1;

    for (; c < o.length;) {
      c <<= 1;
    }

    var u = 2 * c - 1;
    c -= 1;
    var h = a(u);
    var g = 0;

    for (var _t9 = 0; _t9 < s.length; _t9++) {
      var _e4 = s[_t9] + c;

      for (h[_e4]++; _e4 > 0;) {
        _e4 % 2 && (g += h[_e4 + 1]), _e4 = _e4 - 1 >> 1, h[_e4]++;
      }
    }

    return g;
  }

  function Z(t) {
    if (0 === t.length) return -1;
    if (1 === t.length) return t[0];
    if (2 === t.length) return (t[0] + t[1]) / 2;
    if (t.sort(C), t.length % 2) return t[(t.length - 1) / 2];
    var e = t.length / 2,
        n = e - 1,
        r = t[t.length - 1] - t[e],
        o = t[n] - t[0];
    return o == r ? (t[n] + t[e]) / 2 : (t[n] * r + t[e] * o) / (o + r);
  }

  function tt(e, n, o) {
    var l = e.nodes();
    var i, f, s, a, c;
    var u = n.filter(function (t) {
      return 0 !== e.outDegree(t);
    }),
        h = n.filter(function (t) {
      return 0 !== e.inDegree(t);
    });
    if (n.length < 3) return [u, h, X(e, u, h)];
    o ? o % 2 == 1 && o++ : o = 24;
    var g,
        d = r(h),
        p = X(e, u, h),
        m = u.slice(),
        v = h.slice(),
        M = 0;

    var b = function b(t) {
      return d[t.source == g ? t.target.index : t.source.index];
    },
        x = function x(t, n) {
      var r = c[t] - c[n];
      return 0 === r && (r = e.edges(n).length % 2 - e.edges(t).length % 2), r < 0 ? -1 : r > 0 ? 1 : 0;
    };

    for (s = u, f = 0; f < o; f++, s = s == u ? h : u) {
      c = {};

      for (var _t10 = 0; _t10 < s.length; _t10++) {
        g = l[s[_t10]], a = s == u ? e.outEdges(g.index) : e.inEdges(g.index), a = a.map(b), c[g.index] = +Z(a);
      }

      s.sort(x);

      for (var _t11 = 0; _t11 < s.length; _t11++) {
        d = r(s);
      }

      i = X(e, u, h), i < p && (p = i, m = u.slice(), v = h.slice(), M = f, o = Math.max(o, f + 2));
    }

    return t.debug && console.log("Best iter: ".concat(M)), [m, v, p];
  }

  t.debug = !1;

  var et = /*#__PURE__*/function () {
    function et() {
      _classCallCheck(this, et);

      this.length = 0;
    }

    _createClass(et, [{
      key: "push",
      value: function push(t) {
        var e = {
          item: t
        };
        this.last ? this.last = this.last.next = e : this.last = this.first = e, this.length++;
      }
    }, {
      key: "shift",
      value: function shift() {
        var t = this.first;
        if (t) return this.first = t.next, --this.length || (this.last = void 0), t.item;
      }
    }, {
      key: "slice",
      value: function slice() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1 / 0;
        var n = [];
        var r = 0;

        for (var _o2 = this.first; _o2 && !(--e < 0); _o2 = _o2.next) {
          ++r > t && n.push(_o2.item);
        }

        return n;
      }
    }]);

    return et;
  }();

  function nt(t, e, n) {
    var r = new et(),
        o = {};

    for (r.push(e), o[e] = !0, n(e, void 0); r.length;) {
      n(e = r.shift(), e);

      var _l = t.edges(e);

      for (var _i = 0; _i < _l.length; _i++) {
        var _f = _l[_i],
            _s = t.other(_f, e).index;
        o[_s] || (r.push(_s), o[_s] = !0, n(e, _s));
      }

      n(e, -1);
    }
  }

  function rt(t, e) {
    var n = {};
    return n[e] = 0, nt(t, e, function (t, e) {
      e >= 0 && t != e && (n[e] = n[t] + 1);
    }), n;
  }

  function ot(t) {
    return n(0, t.length).sort(function (e, n) {
      return t[e] - t[n];
    });
  }

  var lt = ot;

  function it(e) {
    var n = e.length,
        r = e[0].length,
        o = function (t) {
      var e = t.length,
          n = t[0].length,
          r = a(n);

      for (var _o3 = 0; _o3 < e; _o3++) {
        var _e5 = t[_o3];

        for (var _t12 = 0; _t12 < n; _t12++) {
          r[_t12] += _e5[_t12];
        }
      }

      return r;
    }(e),
        l = function (t) {
      var e = t.length,
          n = t[0].length,
          r = Array(e);

      for (var _o4 = 0; _o4 < e; _o4++) {
        var _e6 = t[_o4];
        var _l2 = 0;

        for (var _t13 = 0; _t13 < n; _t13++) {
          _l2 += _e6[_t13];
        }

        r[_o4] = _l2;
      }

      return r;
    }(e),
        i = function (e, n, r, o, l, i, f) {
      var s, c, u, h, g, d, p, m, v, M, b, x, y, _, w, k, A, $, q, N;

      var z = a(o),
          E = a(o),
          I = a(o),
          j = a(o);
      var O = 0;

      for (var _t14 = 0; _t14 < o; _t14++) {
        O += f[_t14], n[_t14] = _t14 + 1;
      }

      n[0] = 1.1;
      var D = 5e-6;

      for (ft(n, n, e, i, r, o, l), s = 0;;) {
        c = 0;

        for (var _t15 = 0; _t15 < o; _t15++) {
          c += n[_t15] * f[_t15];
        }

        c /= O, h = 0;

        for (var _t16 = 0; _t16 < o; _t16++) {
          u = n[_t16] - c, h += u * u * f[_t16], n[_t16] = u;
        }

        h = Math.sqrt(h);

        for (var _t17 = 0; _t17 < o; _t17++) {
          n[_t17] /= h;
        }

        ft(n, z, e, i, r, o, l), c = 0, g = 0, d = 0, p = 0, m = 0, v = 0, M = 0, b = 0;

        for (var _t18 = 0; _t18 < o; _t18++) {
          u = z[_t18], z[_t18] = u / f[_t18], c += u, g += u * n[_t18];
        }

        c /= O;

        for (var _t19 = 0; _t19 < o; _t19++) {
          u = z[_t19] - (c + g * n[_t19]), d += u * u * f[_t19], z[_t19] = u;
        }

        d = Math.sqrt(d);

        for (var _t20 = 0; _t20 < o; _t20++) {
          z[_t20] /= d;
        }

        if (d < D || s > 999) break;
        s++, ft(z, E, e, i, r, o, l), c = 0, A = 0;

        for (var _t21 = 0; _t21 < o; _t21++) {
          u = E[_t21], E[_t21] = u / f[_t21], c += u, p += u * z[_t21], A += u * n[_t21];
        }

        c /= O;

        for (var _t22 = 0; _t22 < o; _t22++) {
          u = E[_t22] - (c + p * z[_t22] + A * n[_t22]), m += u * u * f[_t22], E[_t22] = u;
        }

        if (m = Math.sqrt(m), m > D) {
          for (var _t23 = 0; _t23 < o; _t23++) {
            E[_t23] /= m;
          }

          ft(E, I, e, i, r, o, l), c = 0, $ = 0, q = 0;

          for (var _t24 = 0; _t24 < o; _t24++) {
            u = I[_t24], I[_t24] /= f[_t24], c += u, v += u * E[_t24], $ += u * n[_t24], q += u * z[_t24];
          }

          c /= O;

          for (var _t25 = 0; _t25 < o; _t25++) {
            u = I[_t25] - (c + v * E[_t25] + $ * n[_t25] + q * z[_t25]), M += u * u * f[_t25], I[_t25] = u;
          }

          if (M = Math.sqrt(M), M > D) {
            for (var _t26 = 0; _t26 < o; _t26++) {
              I[_t26] /= M;
            }

            ft(I, j, e, i, r, o, l);

            for (var _t27 = 0; _t27 < o; _t27++) {
              b += I[_t27] * j[_t27];
            }
          } else M = 0;
        } else m = 0;

        if (x = ut(D, g, d, p, m, v, M, b), y = x[0], _ = x[1], w = x[2], k = x[3], d < D) break;

        for (var _t28 = 0; _t28 < o; _t28++) {
          n[_t28] = y * n[_t28] + _ * z[_t28] + w * E[_t28] + k * I[_t28];
        }
      }

      d > D && t.debug > 0 && console.log("residual bigger than tolerance on axis 1");
      var P = n[0],
          T = n[0];

      for (var _t29 = 1; _t29 < o; _t29++) {
        c = n[_t29], c < T ? T = c : c > P && (P = c);
      }

      if (-T > P) for (var _t30 = 0; _t30 < o; _t30++) {
        n[_t30] = -n[_t30];
      }
      at(n, e, r, o, l);

      for (var _t31 = 0; _t31 < r; _t31++) {
        e[_t31] /= i[_t31];
      }

      var F = 0;

      for (var _t32 = 0; _t32 < r; _t32++) {
        F += i[_t32] * ct(e[_t32]);
      }

      F = Math.sqrt(F);

      for (var _t33 = 0; _t33 < r; _t33++) {
        e[_t33] /= F;
      }

      for (var _t34 = 0; _t34 < o; _t34++) {
        n[_t34] /= F;
      }

      var R,
          S = 0;

      for (var _t35 = 0; _t35 < r; _t35++) {
        R = e[_t35], N = l[_t35];

        for (var _t36 = 0; _t36 < o; _t36++) {
          S += N[_t36] * ct(R - n[_t36]);
        }
      }

      var B = Math.sqrt(S / O);

      if (g >= .999) {
        B = P / F;

        var _t37 = -T / F;

        _t37 > B && (B = _t37);
      }

      for (var _t38 = 0; _t38 < o; _t38++) {
        n[_t38] /= B;
      }

      return {
        rows: e,
        cols: n,
        eig: g
      };
    }(K(n, 1), K(r, 1), n, r, e, l, o);

    if (i.eig < 1e-7) i.rows = i.cols = [], i.eig = 0;else {
      var _t39 = i.rows;
      at(i.cols, _t39, n, r, e);

      for (var _e7 = 0; _e7 < n; _e7++) {
        _t39[_e7] /= l[_e7];
      }
    }
    return i;
  }

  function ft(t, e, n, r, o, l, i, f) {
    f && console.log("TRANS ".concat(f)), at(t, n, o, l, i, f);

    for (var _t40 = 0; _t40 < o; _t40++) {
      n[_t40] = n[_t40] / r[_t40];
    }

    !function (t, e, n, r, o, l) {
      l && (console.log("xymult"), st(e));

      for (var _t41 = 0; _t41 < r; _t41++) {
        e[_t41] = 0;
      }

      for (var _l3 = 0; _l3 < n; _l3++) {
        var _n3 = t[_l3],
            _i2 = o[_l3];

        for (var _t42 = 0; _t42 < r; _t42++) {
          e[_t42] += _n3 * _i2[_t42];
        }
      }

      l && st(e);
    }(n, e, o, l, i, f);
  }

  function st(t) {
    console.log("");

    for (var _e8 = 0; _e8 < t.length; _e8++) {
      console.log("i:".concat(_e8 + 1, " v:  ").concat(t[_e8].toFixed(5)));
    }
  }

  function at(t, e, n, r, o, l) {
    l && (console.log("yxmult"), st(e));

    for (var _l4 = 0; _l4 < n; _l4++) {
      var _n4 = 0;
      var _i3 = o[_l4];

      for (var _e9 = 0; _e9 < r; _e9++) {
        _n4 += t[_e9] * _i3[_e9];
      }

      e[_l4] = _n4;
    }

    l && st(e);
  }

  function ct(t) {
    return t * t;
  }

  function ut(t, e, n, r, o, l, i, f) {
    var s,
        a,
        c,
        u,
        h,
        g,
        d,
        p = 1,
        m = .1,
        v = .01,
        M = .001;

    for (var _b = 0; _b < 100 && (s = e * p + n * m, a = n * p + r * m + o * v, c = o * m + l * v + i * M, u = i * v + f * M, p = e * s + n * a, m = n * s + r * a + o * c, v = o * a + l * c + i * u, M = i * c + f * u, h = Math.sqrt(ct(p) + ct(m) + ct(v) + ct(M)), p /= h, m /= h, v /= h, M /= h, (_b + 1) % 5 == 0 && (g = Math.sqrt(h), d = Math.sqrt(ct(p - s / g) + ct(m - a / g) + ct(v - c / g) + ct(M - u / g))), !(d < .05 * t)); _b++) {
      ;
    }

    return [p, m, v, M];
  }

  var ht = it,
      gt = it;
  var dt = {
    pearson: function pearson(t, e) {
      var n = L(t),
          r = L(e),
          o = Math.min(t.length, e.length);
      if (0 === o) return NaN;
      var l = 0,
          i = 0,
          f = 0;

      for (var _s2 = 0; _s2 < o; _s2++) {
        var _o5 = t[_s2] - n,
            _a = e[_s2] - r;

        l += _o5 * _a, i += _o5 * _o5, f += _a * _a;
      }

      return l / Math.sqrt(i * f);
    },
    pearsonMatrix: function pearsonMatrix(t) {
      var e = dt.pearson,
          n = t.length;
      if (0 === n) return NaN;
      var r = a(n, n);

      for (var _o6 = 0; _o6 < n - 1; _o6++) {
        for (var _l5 = _o6 + 1; _l5 < n; _l5++) {
          var _n5 = e(t[_o6], t[_l5]);

          r[_o6][_l5] = r[_l5][_o6] = _n5;
        }
      }

      return r;
    }
  },
      pt = B;

  function mt(t, e, n) {
    var r = t.length;
    var o = 0;

    for (var _l6 = 0; _l6 < r; _l6++) {
      o += t[_l6][e] * t[_l6][n];
    }

    return o;
  }

  function vt(t) {
    var e = t[0].length,
        n = Array(e);

    for (var _t43 = 0; _t43 < e; _t43++) {
      n[_t43] = Array(e);
    }

    for (var _r4 = 0; _r4 < e; _r4++) {
      for (var _o7 = _r4; _o7 < e; _o7++) {
        n[_r4][_o7] = n[_o7][_r4] = mt(t, _r4, _o7);
      }
    }

    return n;
  }

  function Mt(t, e) {
    if (e.length < 3) return e;
    var n = {},
        o = new et(),
        l = r(e),
        i = [];
    var f = e[0],
        s = t.degree(f);

    for (var _n6 = 0; _n6 < e.length; _n6++) {
      var _r5 = e[_n6];
      if (t.degree(_r5) < s && (s = t.degree(_r5), f = _r5, 1 == s)) break;
    }

    var _loop = function _loop() {
      var e = o.shift();
      if (n[e]) return "continue";
      n[e] = !0, i.push(e);
      t.edges(e).map(function (n) {
        return t.other(n, e).index;
      }).filter(function (t) {
        return !n[t] && t in l;
      }).sort(function (e, n) {
        return t.degree(e) - t.degree(n);
      }).forEach(o.push, o);
    };

    for (o.push(f); 0 !== o.length;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }

    return i;
  }

  function bt(t, e) {
    return Mt(t, e).reverse();
  }

  function xt(t, e, n, r) {
    r || (r = "");

    for (var _o8 = 0; _o8 < t.length; _o8++) {
      0 !== r.length && (r += ", "), r += n ? t[n[_o8]].toFixed(e) : t[_o8].toFixed(e);
    }

    console.log(r);
  }

  function yt(t, e, n, r) {
    e || (e = 4);

    for (var _o9 = 0; _o9 < t.length; _o9++) {
      xt(n ? t[n[_o9]] : t[_o9], e, r, "".concat(_o9, ": "));
    }
  }

  function _t(t, e) {
    if (!t) throw console.log(e), e || "Assertion failed";
  }

  function wt(t, e) {
    return null === t.left ? "".concat(Array(e + 1).join(" "), "id: ").concat(t.id) : "".concat(Array(e + 1).join(" "), "id: ").concat(t.id, ", dist: ").concat(t.dist, "\n").concat(wt(t.left, e + 1), "\n").concat(wt(t.right, e + 1));
  }

  function kt(t, e) {
    return !(isNaN(t) || isNaN(e) || t == 1 / 0 || e == 1 / 0);
  }

  var At = {
    euclidean: function euclidean(t, e) {
      var n = 0;

      for (var _r6 = t.length; _r6 > 0; _r6--) {
        if (kt(t[_r6], e[_r6])) {
          var _o10 = t[_r6] - e[_r6];

          n += _o10 * _o10;
        }
      }

      return Math.sqrt(n);
    },
    manhattan: function manhattan(t, e) {
      var n = 0;

      for (var _r7 = t.length; _r7 > 0; _r7--) {
        kt(t[_r7], e[_r7]) && (n += Math.abs(t[_r7] - e[_r7]));
      }

      return n;
    },
    minkowski: function minkowski(t) {
      return function (e, n) {
        var r = 0;

        for (var _o11 = e.length; _o11 > 0; _o11--) {
          kt(e[_o11], n[_o11]) && (r += Math.pow(Math.abs(e[_o11] - n[_o11]), t));
        }

        return Math.pow(r, 1 / t);
      };
    },
    chebyshev: function chebyshev(t, e) {
      var n = 0;

      for (var _r8 = t.length; _r8 > 0; _r8--) {
        if (kt(t[_r8], e[_r8])) {
          var _o12 = Math.abs(t[_r8] - e[_r8]);

          _o12 > n && (n = _o12);
        }
      }

      return n;
    },
    hamming: function hamming(t, e) {
      var n = 0;

      for (var _r9 = t.length; _r9 > 0; _r9--) {
        kt(t[_r9], e[_r9]) && t[_r9] !== e[_r9] && n++;
      }

      return n;
    },
    jaccard: function jaccard(t, e) {
      var n = 0,
          r = 0;

      for (var _o13 = t.length; _o13 > 0; _o13--) {
        kt(t[_o13], e[_o13]) && (t[_o13] === e[_o13] && r++, n++);
      }

      return 0 === n ? 0 : r / n;
    },
    braycurtis: function braycurtis(t, e) {
      var n = 0,
          r = 0;

      for (var _o14 = t.length; _o14 > 0; _o14--) {
        var _l7 = t[_o14],
            _i4 = e[_o14];
        kt(_l7, _i4) && (n += Math.abs(_l7 - _i4), r += Math.abs(_l7 + _i4));
      }

      return 0 === r ? 0 : n / r;
    }
  };

  function $t() {
    var t = At.euclidean;

    function e(e) {
      var n = e.length,
          r = [];

      for (var _o15 = 0; _o15 < n; _o15++) {
        var _l8 = [];
        r[_o15] = _l8;

        for (var _i5 = 0; _i5 < n; _i5++) {
          _i5 < _o15 ? _l8.push(r[_i5][_o15]) : _o15 === _i5 ? _l8.push(0) : _l8.push(t(e[_o15], e[_i5]));
        }
      }

      return r;
    }

    return e.distance = function (n) {
      return arguments.length ? (t = n, e) : t;
    }, e;
  }

  function qt(t) {
    var e = 0;
    var n = t.length;

    for (var _r10 = 0; _r10 < n; _r10++) {
      var _o16 = t[_r10];

      for (var _t44 = _r10 + 1; _t44 < n; _t44++) {
        _o16[_t44] > e && (e = _o16[_t44]);
      }
    }

    return e;
  }

  function Nt(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e + 1;
    t.splice(e, n - e);

    for (var _r11 = t.length; _r11-- > 0;) {
      t[_r11].splice(e, n - e);
    }

    return t;
  }

  function zt(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.length;
    var r = n - e;

    for (; r > 0;) {
      var _n7 = e + Math.floor(Math.random() * r--),
          _o17 = t[e + r];

      t[e + r] = t[_n7], t[_n7] = _o17;
    }

    return t;
  }

  function Et(t, e, n) {
    var r = Array(t);
    if (1 == arguments.length) for (; t;) {
      r[--t] = Math.random();
    } else if (2 == arguments.length) for (; t;) {
      r[--t] = Math.random() * e;
    } else for (; t;) {
      r[--t] = e + Math.random() * (n - e);
    }
    return r;
  }

  function It(t) {
    var e = Q(t);
    var n = t.length;
    if (0 === e || Math.abs(e - 1) < 1e-9) return 1;

    for (; n-- > 0;) {
      t[n] /= e;
    }

    return e;
  }

  function jt(t, e, n) {
    e || (e = 1e-9);
    var r = t.length;
    var o,
        l = Array(r),
        i = 100;

    for (_t(r == t[0].length, "poweriteration needs a square matrix"), o = n ? n.slice() : Et(r), It(o); i-- > 0;) {
      for (var _e10 = 0; _e10 < r; _e10++) {
        l[_e10] = 0;

        for (var _n9 = 0; _n9 < r; _n9++) {
          l[_e10] += t[_e10][_n9] * o[_n9];
        }
      }

      if (It(l), B(l, o) > 1 - e) break;
      var _n8 = l;
      l = o, o = _n8;
    }

    return l;
  }

  function Ot(e, n, r, o, l) {
    o || (o = 1e-9);
    var i = e.length,
        f = Array(n);
    var s = Array(i),
        a = 100;
    var c = Array(n);
    if (_t(i == e[0].length, "poweriteration needs a square matrix"), r) for (var _t45 = 0; _t45 < n; _t45++) {
      f[_t45] = r[_t45].slice(), c[_t45] = It(f[_t45]);
    } else for (var _t46 = 0; _t46 < n; _t46++) {
      var _e11 = f[_t46] = Et(i);

      c[_t46] = It(_e11);
    }
    l || (l = 0);

    for (var _r12 = l; _r12 < n; _r12++) {
      var _n10 = f[_r12];

      for (; a-- > 0;) {
        for (var _t47 = 0; _t47 < _r12; _t47++) {
          var _e12 = f[_t47],
              _r13 = B(_n10, _e12);

          for (var _t48 = 0; _t48 < i; _t48++) {
            _n10[_t48] -= _r13 * _e12[_t48];
          }
        }

        for (var _t49 = 0; _t49 < i; _t49++) {
          s[_t49] = 0;

          for (var _r14 = 0; _r14 < i; _r14++) {
            s[_t49] += e[_t49][_r14] * _n10[_r14];
          }
        }

        if (c[_r12] = It(s), B(s, _n10) > 1 - o) break;
        _n10 = s, s = f[_r12], f[_r12] = _n10;
      }

      t.debug && console.log("eig[%d]=%j", _r12, _n10);
    }

    return [f, c];
  }

  function Dt(e, n) {
    var r = function (e) {
      var n = 0;
      var r = e.length;

      for (var _t50 = 0; _t50 < r; _t50++) {
        var _o18 = e[_t50];
        var _l9 = _o18[_t50];

        for (var _e13 = 0; _e13 < r; _e13++) {
          _e13 != _t50 && (_l9 += Math.abs(_o18[_e13]));
        }

        _l9 > n && (n = _l9);
      }

      return t.debug && console.log("gershgorin_bound=%d", n), n;
    }(e),
        o = e.length,
        l = e.map(function (t) {
      return t.slice();
    });

    for (var _t51 = 0; _t51 < o; _t51++) {
      var _e14 = l[_t51];

      for (var _n11 = 0; _n11 < o; _n11++) {
        _e14[_n11] = _t51 == _n11 ? r - _e14[_n11] : -_e14[_n11];
      }
    }

    return Ot(l, 2, [K(o, 1), Et(o)], n, 1)[0][1];
  }

  function Pt(e, n, r) {
    var o = {};
    var l,
        i,
        f,
        s,
        a = 1;
    return o.nodes = function (t) {
      return arguments.length ? (e = t, o) : e;
    }, o.nodes_indices = function () {
      return e.map(function (t) {
        return t.index;
      });
    }, o.generate_nodes = function (t) {
      e = [];

      for (var _n12 = 0; _n12 < t; _n12++) {
        e.push({
          id: _n12
        });
      }

      return o;
    }, o.links = function (t) {
      return arguments.length ? (n = t, o) : n;
    }, o.links_indices = function () {
      return n.map(function (t) {
        return {
          source: t.source.index,
          target: t.target.index
        };
      });
    }, o.linkDistance = function (t) {
      return arguments.length ? (a = "function" == typeof t ? t : +t, o) : a;
    }, o.directed = function (t) {
      return arguments.length ? (r = t, o) : r;
    }, o.init = function () {
      var t = e.length,
          c = n.length;
      s = void 0;

      for (var _n13 = 0; _n13 < t; ++_n13) {
        var _t52 = e[_n13];
        _t52.index = _n13, _t52.weight = 0;
      }

      for (var _t53 = 0; _t53 < c; ++_t53) {
        var _r15 = n[_t53];
        _r15.index = _t53, "number" == typeof _r15.source && (_r15.source = e[_r15.source]), "number" == typeof _r15.target && (_r15.target = e[_r15.target]), "value" in _r15 || (_r15.value = 1), _r15.source.weight++, _r15.target.weight++;
      }

      if ("function" == typeof a) for (var _t54 = 0; _t54 < c; ++_t54) {
        n[_t54].distance = +a.call(this, n[_t54], _t54);
      } else for (var _t55 = 0; _t55 < c; ++_t55) {
        n[_t55].distance = a;
      }
      l = Array(e.length);

      for (var _t56 = 0; _t56 < e.length; ++_t56) {
        l[_t56] = [];
      }

      if (r) {
        i = Array(e.length), f = Array(e.length);

        for (var _t57 = 0; _t57 < e.length; ++_t57) {
          i[_t57] = [], f[_t57] = [];
        }
      } else i = f = l;

      for (var _t58 = 0; _t58 < n.length; ++_t58) {
        var _e15 = n[_t58];
        l[_e15.source.index].push(_e15), _e15.source.index != _e15.target.index && l[_e15.target.index].push(_e15), r && i[_e15.source.index].push(_e15), r && f[_e15.target.index].push(_e15);
      }

      return o;
    }, o.edges = function (e) {
      return "number" != typeof e && (e = e.index, t.debug && console.log("received node %d", e)), l[e];
    }, o.degree = function (t) {
      return "number" != typeof t && (t = t.index), l[t].length;
    }, o.inEdges = function (t) {
      return "number" != typeof t && (t = t.index), i[t];
    }, o.inDegree = function (t) {
      return "number" != typeof t && (t = t.index), i[t].length;
    }, o.outEdges = function (t) {
      return "number" != typeof t && (t = t.index), f[t];
    }, o.outDegree = function (t) {
      return "number" != typeof t && (t = t.index), f[t].length;
    }, o.sinks = function () {
      var t = [];

      for (var _n14 = 0; _n14 < e.length; _n14++) {
        0 === o.outEdges(_n14).length && t.push(_n14);
      }

      return t;
    }, o.sources = function () {
      var t = [];

      for (var _n15 = 0; _n15 < e.length; _n15++) {
        0 === o.inEdges(_n15).length && t.push(_n15);
      }

      return t;
    }, o.distance = function (t) {
      return n[t].distance;
    }, o.neighbors = function (t) {
      var e = l[t],
          n = [];

      var _iterator = _createForOfIteratorHelper(e),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _r16 = _step.value;
          _r16.source.index == t ? n.push(_r16.target) : n.push(_r16.source);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return n;
    }, o.other = function (t, e) {
      return "number" == typeof t && (t = n[t]), t.source.index === e ? t.target : t.source;
    }, o.components = function () {
      return s || (s = function () {
        var t = [],
            n = [],
            r = e.length;

        for (var _t59 = 0; _t59 < r; _t59++) {
          e[_t59].comp = 0;
        }

        for (var _o19 = 0, _i6 = 0; _o19 < r; _o19++) {
          if (0 !== e[_o19].comp) continue;
          _i6 += 1, e[_o19].comp = _i6, t.push(_o19);
          var _r17 = [_o19];

          for (; t.length;) {
            var _e16 = t.shift(),
                _n16 = l[_e16];

            for (var _o20 = 0; _o20 < _n16.length; _o20++) {
              var _l10 = _n16[_o20];
              var _f2 = _l10.source;
              _f2.index == _e16 && (_f2 = _l10.target), _f2.index != _e16 && 0 === _f2.comp && (_f2.comp = _i6, _r17.push(_f2.index), t.push(_f2.index));
            }
          }

          _r17.length && (_r17.sort(C), n.push(_r17));
        }

        return n.sort(function (t, e) {
          return e.length - t.length;
        }), n;
      }()), s;
    }, o;
  }

  function Tt(t, e) {
    var n = e.length;
    var r = t.slice();

    for (; n--;) {
      r[n] = t[e[n]];
    }

    return r;
  }

  function Ft(t) {
    var e = t.length,
        n = a(e, e),
        r = qt(t);

    for (var _o21 = 0; _o21 < e; _o21++) {
      for (var _l11 = _o21; _l11 < e; _l11++) {
        n[_l11][_o21] = n[_o21][_l11] = 1 + r - t[_o21][_l11];
      }
    }

    return n;
  }

  function Rt(t) {
    var e = Array(t);

    for (var _n17 = 0; _n17 < t; _n17++) {
      e[_n17] = {
        id: _n17
      };
    }

    return e;
  }

  function St(t, e) {
    return Pt(Rt(t), [], e);
  }

  function Bt(t, e) {
    var n = Rt(t),
        r = [];
    if (e) for (var _e17 = 0; _e17 < t; _e17++) {
      for (var _n18 = 0; _n18 < t; _n18++) {
        _e17 != _n18 && r.push({
          source: _e17,
          target: _n18
        });
      }
    } else for (var _e18 = 0; _e18 < t - 1; _e18++) {
      for (var _n19 = _e18 + 1; _n19 < t; _n19++) {
        r.push({
          source: _e18,
          target: _n19
        });
      }
    }
    return Pt(n, r, e).init();
  }

  function Qt(t, e, n) {
    if (e <= 0) return St(t, n);
    if (e >= 1) return Bt(t, n);
    var r = Rt(t),
        o = [];
    var l = -1,
        i = Math.log(1 - e);
    if (n) for (var _e19 = 0; _e19 < t;) {
      var _n20 = Math.log(1 - Math.random());

      for (l = l + 1 + Math.floor(_n20 / i), _e19 == l && (l += 1); l >= t && _e19 < t;) {
        l -= t, _e19 += 1, _e19 == l && (l += 1);
      }

      _e19 < t && o.push({
        source: _e19,
        target: l
      });
    } else for (var _e20 = 1; _e20 < t;) {
      var _n21 = Math.log(1 - Math.random());

      for (l = l + 1 + Math.floor(_n21 / i); l >= _e20 && _e20 < t;) {
        l -= _e20, _e20 += 1;
      }

      _e20 < t && o.push({
        source: _e20,
        target: l
      });
    }
    return Pt(r, o, n).init();
  }

  var Vt = Qt;

  function Gt() {
    var t = At.euclidean,
        e = "single",
        n = null;

    function r(r) {
      var o = r.length,
          l = [],
          i = [],
          f = [];
      var s,
          a = 0;

      if (null === n) {
        n = [];

        var _e21 = -1;

        for (; ++_e21 < o;) {
          l[_e21] = 0, n[_e21] = [];

          var _i7 = -1;

          for (; ++_i7 < o;) {
            n[_e21][_i7] = _e21 === _i7 ? 1 / 0 : t(r[_e21], r[_i7]), n[_e21][l[_e21]] > n[_e21][_i7] && (l[_e21] = _i7);
          }
        }
      } else {
        if (n.length < o || n[0].length < o) throw {
          error: "Provided distance matrix length ".concat(n.length, " instead of ").concat(o)
        };

        var _t60 = -1;

        for (; ++_t60 < o;) {
          l[_t60] = 0;

          var _e22 = -1;

          for (; ++_e22 < o;) {
            _t60 === _e22 && (n[_t60][_e22] = 1 / 0), n[_t60][l[_t60]] > n[_t60][_e22] && (l[_t60] = _e22);
          }
        }
      }

      var c = -1;

      for (; ++c < o;) {
        c != a && console.log("i = %d, id = %d", c, a), f[c] = [], f[c][0] = {
          left: null,
          right: null,
          dist: 0,
          centroid: r[c],
          id: a++,
          size: 1,
          depth: 0
        }, i[c] = 1;
      }

      for (var _t61 = 0; _t61 < o - 1; _t61++) {
        var _t62 = 0;

        for (c = 0; c < o; c++) {
          n[c][l[c]] < n[_t62][l[_t62]] && (_t62 = c);
        }

        var _r18 = l[_t62],
            _u = f[_t62][0],
            _h = f[_r18][0],
            _g = {
          left: _u,
          right: _h,
          dist: n[_t62][_r18],
          centroid: Lt(_u.size, _u.centroid, _h.size, _h.centroid),
          id: a++,
          size: _u.size + _h.size,
          depth: 1 + Math.max(_u.depth, _h.depth)
        };
        f[_t62].splice(0, 0, _g), i[_t62] += i[_r18];

        for (var _l12 = 0; _l12 < o; _l12++) {
          switch (e) {
            case "single":
              n[_t62][_l12] > n[_r18][_l12] && (n[_l12][_t62] = n[_t62][_l12] = n[_r18][_l12]);
              break;

            case "complete":
              n[_t62][_l12] < n[_r18][_l12] && (n[_l12][_t62] = n[_t62][_l12] = n[_r18][_l12]);
              break;

            case "average":
              n[_l12][_t62] = n[_t62][_l12] = (i[_t62] * n[_t62][_l12] + i[_r18] * n[_r18][_l12]) / (i[_t62] + i[_l12]);
          }
        }

        n[_t62][_t62] = 1 / 0;

        for (var _t63 = 0; _t63 < o; _t63++) {
          n[_t63][_r18] = n[_r18][_t63] = 1 / 0;
        }

        for (var _e23 = 0; _e23 < o; _e23++) {
          l[_e23] == _r18 && (l[_e23] = _t62), n[_t62][_e23] < n[_t62][l[_t62]] && (l[_t62] = _e23);
        }

        s = _g;
      }

      return s;
    }

    return r.linkage = function (t) {
      return arguments.length ? (e = t, r) : e;
    }, r.distance = function (e) {
      return arguments.length ? (t = e, r) : t;
    }, r.distanceMatrix = function (t) {
      return arguments.length ? (n = t.map(function (t) {
        return t.slice(0);
      }), r) : n;
    }, r;
  }

  function Lt(t, e, n, r) {
    var o = [],
        l = t + n,
        i = e.length;
    var f = -1;

    for (; ++f < i;) {
      o[f] = (t * e[f] + n * r[f]) / l;
    }

    return o;
  }

  function Yt(t, e) {
    var n = e.length,
        o = a(n, n),
        l = r(e);

    _t(!t.directed(), "Laplacian only for undirected graphs");

    for (var _r19 = 0; _r19 < n; _r19++) {
      var _n22 = e[_r19],
          _i8 = o[_r19];
      var _f3 = 0;

      var _s3 = t.edges(_n22);

      for (var _e24 = 0; _e24 < _s3.length; _e24++) {
        var _o22 = _s3[_e24],
            _a2 = l[t.other(_o22, _n22).index];
        _a2 != _r19 && (_f3 += _o22.value, _i8[_a2] = -_o22.value);
      }

      _i8[_r19] = _f3;
    }

    return o;
  }

  function Ct(t) {
    var e = t.length;
    if (0 === e) return NaN;
    var n = t[0].length,
        r = t[0].slice(0);
    var o = 0;

    for (; ++o < e;) {
      var _e25 = t[o];

      for (var _t64 = 0; _t64 < n; _t64++) {
        r[_t64] += (_e25[_t64] - r[_t64]) / (o + 1);
      }
    }

    return r;
  }

  function Ht() {
    var e = null,
        n = At.euclidean,
        r = "complete",
        o = {},
        l = {};

    function i(t) {
      return null === t ? [] : t.id in o ? o[t.id] : o[t.id] = function (t) {
        if (null === t) return [];
        if (0 === t.depth) return [t.id];
        return i(t.left).concat(i(t.right));
      }(t);
    }

    function f(t, n, r) {
      var o = "k".concat(t.id, "-").concat(n, "-").concat(r);
      return o in l ? l[o] : l[o] = function (t, n, r) {
        if (0 === t.depth) return [0, [t.id]];
        var o = t.left,
            l = t.right,
            s = i(o),
            a = i(l);
        var c, u;
        if (s.includes(n) && a.includes(r)) c = o, u = l;else {
          if (!a.includes(n) || !s.includes(r)) throw {
            error: "Node is not common ancestor of ".concat(n, ", ").concat(r)
          };
          c = l, u = o;
        }
        var h = i(c.left),
            g = i(c.right);
        var d = g.includes(n) ? h : g;
        0 === d.length && (d = [n]);
        var p = i(u.left),
            m = i(u.right);
        var v = m.includes(r) ? p : m;
        0 === v.length && (v = [r]);
        var M = 1 / 0,
            b = [];

        for (var _t65 = 0; _t65 < d.length; _t65++) {
          var _o23 = f(c, n, d[_t65]);

          for (var _n23 = 0; _n23 < v.length; _n23++) {
            var _l13 = f(u, v[_n23], r),
                _i9 = _o23[0] + e[d[_t65]][v[_n23]] + _l13[0];

            _i9 < M && (M = _i9, b = _o23[1].concat(_l13[1]));
          }
        }

        return [M, b];
      }(t, n, r);
    }

    function s(n) {
      o = {}, l = {};
      var r = 1 / 0,
          s = [];
      var a = i(n.left),
          c = i(n.right);
      t.debug && console.log(wt(n, 0));

      for (var _t66 = 0; _t66 < a.length; _t66++) {
        for (var _e26 = 0; _e26 < c.length; _e26++) {
          var _o24 = f(n, a[_t66], c[_e26]);

          _o24[0] < r && (r = _o24[0], s = _o24[1]);
        }
      }

      return e = null, s;
    }

    function a(t) {
      null === e && (e = $t().distance(n)(t));
      return s(Gt().linkage(r).distanceMatrix(e)(t));
    }

    return a.order = s, a.reorder = a, a.distance = function (t) {
      return arguments.length ? (n = t, e = null, a) : n;
    }, a.linkage = function (t) {
      return arguments.length ? (r = t, a) : r;
    }, a.distance_matrix = function (t) {
      return arguments.length ? (e = t.map(function (t) {
        return t.slice(0);
      }), a) : e;
    }, a.distanceMatrix = a.distance_matrix, a;
  }

  function Jt(t, e) {
    if (0 === t.length) return null;
    return jt(vt(t = function (t) {
      var e = t.length;
      if (0 === e) return null;
      var n = Ct(t),
          r = n.length,
          o = Array(e);

      for (var _l14 = 0; _l14 < e; _l14++) {
        var _e27 = t[_l14].slice(0);

        for (var _t67 = 0; _t67 < r; _t67++) {
          _e27[_t67] -= n[_t67];
        }

        o[_l14] = _e27;
      }

      return o;
    }(t)), e);
  }

  function Kt(n, r) {
    r || (r = e(n.length));
    var o = dt.pearsonMatrix(n),
        l = o.map(function (t) {
      return t.map(Math.abs);
    });
    var i = Ht().distanceMatrix(l)(n);
    return [Tt(r, i), function (e, n) {
      var r = [1];
      var o = 1,
          l = 0;

      for (var _t68 = 1; _t68 < e.length; _t68++) {
        n[e[_t68 - 1]][e[_t68]] < 0 && (o = -o), o < 0 ? (r.push(-1), l++) : r.push(1);
      }

      if (t.debug && console.log(r), l > e.length / 2) for (var _t69 = 0; _t69 < e.length; _t69++) {
        r[_t69] = -r[_t69];
      }
      return r;
    }(i, o), i, o];
  }

  t.adjacent_exchange = function (t, e, n) {
    e = e.slice(), n = n.slice();
    var i = r(e),
        f = r(n);
    var s = !0,
        a = 0;

    for (; s;) {
      s = !1;

      for (var _n24 = 0; _n24 < e.length - 1; _n24++) {
        var _r20 = e[_n24],
            _o25 = e[_n24 + 1],
            _c = l(t, _r20, _o25, f),
            _u2 = l(t, _o25, _r20, f);

        _c > _u2 && (e[_n24] = _o25, e[_n24 + 1] = _r20, i[_o25] = _n24, i[_r20] = _n24 + 1, s = !0, a += _c - _u2);
      }

      for (var _e28 = 0; _e28 < n.length - 1; _e28++) {
        var _r21 = n[_e28],
            _l15 = n[_e28 + 1],
            _c2 = o(t, _r21, _l15, i),
            _u3 = o(t, _l15, _r21, i);

        _c2 > _u3 && (n[_e28] = _l15, n[_e28 + 1] = _r21, f[_l15] = _e28, f[_r21] = _e28 + 1, s = !0, a += _c2 - _u3);
      }
    }

    return [e, n, a];
  }, t.all_pairs_distance = U, t.all_pairs_distance_bfs = function (t, e) {
    e || (e = [t.nodes_indices()]);
    var n = e.reduce(H).sort(C),
        r = Array(n.length);

    for (var _t70 = 0; _t70 < n.length; _t70++) {
      r[_t70] = Array(n.length);
    }

    for (var _e29 = 0; _e29 < n.length; _e29++) {
      var _n25 = rt(t, _e29);

      for (var _t71 in _n25) {
        r[_e29][_t71] = _n25[_t71], r[_t71][_e29] = _n25[_t71];
      }
    }

    return r;
  }, t.all_pairs_distance_floyd_warshall = W, t.array1d = K, t.array_to_dicts = function (t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e(t[0].length);
    var r = [];

    for (var _e30 = 0; _e30 < t.length; _e30++) {
      var _o26 = t[_e30],
          _l16 = {};

      for (var _t72 = 0; _t72 < _o26.length; _t72++) {
        _l16[n[_t72]] = _o26[_t72];
      }

      r.push(_l16);
    }

    return r;
  }, t.assert = _t, t.bandwidth = function (t, n) {
    n || (n = e(t.nodes().length));
    var o = r(n),
        l = t.links();
    var i = 0;

    for (var _t73 = 0; _t73 < l.length; _t73++) {
      var _e31 = l[_t73],
          _n26 = Math.abs(o[_e31.source.index] - o[_e31.target.index]);

      i = Math.max(i, _n26);
    }

    return i;
  }, t.barycenter = tt, t.barycenter_order = function (t, e, n) {
    var r = [[], [], 0];
    e || (e = t.components());

    for (var _o27 = 0; _o27 < e.length; _o27++) {
      var _l17 = tt(t, e[_o27], n);

      r = [r[0].concat(_l17[0]), r[1].concat(_l17[1]), r[2] + _l17[2]];
    }

    return r;
  }, t.bfs = nt, t.bfs_distances = rt, t.bfs_order = function (t, e) {
    e || (e = t.components());
    var n = [];

    for (var _r22 = 0; _r22 < e.length; _r22++) {
      nt(t, e[_r22][0], function (t, e) {
        e >= 0 && t != e && n.push(t);
      });
    }

    return n;
  }, t.ca = gt, t.ca_decorana = ht, t.ca_order = function (t) {
    var e = gt(t);
    return {
      rows: ot(e.rows),
      cols: ot(e.cols),
      details: e
    };
  }, t.check_distance_matrix = function (t, e) {
    var n = t.length;
    if (e || (e = 1e-10), n != t[0].length) return "Inconsistent dimensions";

    for (var _r23 = 0; _r23 < n - 1; _r23++) {
      var _o28 = t[_r23];
      var _l18 = _o28[_r23];
      if (_l18 < 0) return "Negative value at diagonal ".concat(_r23);
      if (_l18 > e) return "Diagonal not zero at ".concat(_r23);

      for (var _i10 = 1; _i10 < n; _i10++) {
        _l18 = _o28[_i10];
        var _n27 = t[_i10][_r23];
        if (Math.abs(_l18 - _n27) > e) return "Inconsistency at ".concat(_r23, ",").concat(_i10);
        if (_l18 < 0) return "Negative value at ".concat(_r23, ",").concat(_i10);
        if (_n27 < 0) return "Negative value at ".concat(_i10, ",").concat(_r23);
      }
    }

    return !1;
  }, t.cmp_number = C, t.cmp_number_asc = Y, t.cmp_number_desc = function (t, e) {
    return e - t;
  }, t.complete_graph = Bt, t.condition = function (t) {
    var e, n;
    var r = [];

    for (var _o29 = 0; 0 < t.length; _o29++) {
      var _l19 = t[_o29].slice();

      var _i11 = void 0;

      for (_l19.push(r), _i11 = 0; _i11 < r.length; _i11++) {
        if (null !== _l19[_i11]) {
          e = n = _l19[_i11];
          break;
        }
      }

      for (; _i11 < r.length; _i11++) {
        var _t74 = _l19[_i11];
        _t74 < e ? e = _t74 : _t74 > n && (n = _t74);
      }

      var _f4 = n != e ? 1 / (n - e) : 0;

      for (_i11 = 1; _i11 < r.length; _i11++) {
        var _t75 = _l19[_i11];
        null !== _t75 && _t75 >= _t75 && (_l19[_i11] = _l19[_i11] * _f4 - e);
      }
    }

    return r;
  }, t.correlation = dt, t.count_crossings = X, t.covariance = pt, t.covariancetranspose = mt, t.cuthill_mckee = Mt, t.cuthill_mckee_order = function (t, e) {
    var n,
        r = [];
    e || (e = t.components());

    for (var _o30 = 0; _o30 < e.length; _o30++) {
      n = e[_o30], r = r.concat(Mt(t, n));
    }

    return r;
  }, t.dicts_to_array = function (t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(t[0]);
    var n = e.length,
        r = t.length,
        o = Array(r);

    for (var _l20 = 0; _l20 < r; _l20++) {
      var _r24 = Array(n);

      o[_l20] = _r24;

      for (var _o31 = 0; _o31 < n; _o31++) {
        _r24[_o31] = t[_l20][e[_o31]];
      }
    }

    return o;
  }, t.displaymat = function (t, e, n) {
    console.log("Matrix:");

    for (var _r25 = 0; _r25 < t.length; _r25++) {
      var _o32 = e ? t[e[_r25]] : t[_r25];

      var _l21 = "";

      for (var _t76 = 0; _t76 < _o32.length; _t76++) {
        _l21 += (n ? _o32[n[_t76]] : _o32[_t76]) ? "*" : " ";
      }

      console.log(_l21);
    }
  }, t.dist = $t, t.dist_remove = Nt, t.distance = At, t.distmat2valuemat = Ft, t.distmax = qt, t.distmin = function (t) {
    var e = 1 / 0;
    var n = t.length;

    for (var _r26 = 0; _r26 < n; _r26++) {
      var _o33 = t[_r26];

      for (var _t77 = _r26 + 1; _t77 < n; _t77++) {
        _o33[_t77] < e && (e = _o33[_t77]);
      }
    }

    return e;
  }, t.dot = B, t.edgesum = function (t, n) {
    n || (n = e(t.nodes().length));
    var o = r(n),
        l = t.links();
    var i = 0;

    for (var _t78 = 0; _t78 < l.length; _t78++) {
      var _e32 = l[_t78];
      i += Math.abs(o[_e32.source.index] - o[_e32.target.index]);
    }

    return i;
  }, t.fiedler_vector = Dt, t.fix_distance_matrix = function (t, e) {
    var n = t.length;
    if (e || (e = 1e-10), n != t[0].length) throw "Inconsistent dimensions ".concat(n, " != ").concat(t[0].length);

    for (var _r27 = 0; _r27 < n - 1; _r27++) {
      var _o34 = t[_r27];
      var _l22 = _o34[_r27];

      if (_l22 < 0) {
        if (-_l22 > e) throw "Negative value at diagonal".concat(_r27);
        _l22 = _o34[_r27] = 0;
      } else if (_l22 > e) throw "Diagonal not zero at ".concat(_r27);

      for (var _i12 = 1; _i12 < n; _i12++) {
        _l22 = _o34[_i12];
        var _n28 = t[_i12][_r27];
        if (Math.abs(_l22 - _n28) > e) throw "Inconsistency at ".concat(_r27, ",").concat(_i12);
        _l22 < 0 && (_l22 = 0), _n28 < 0 && (_n28 = 0), _l22 != _n28 && (_l22 += _n28, _l22 /= 2), _o34[_i12] = _l22, t[_i12][_r27] = _l22;
      }
    }

    return t;
  }, t.flatten = H, t.floyd_warshall_path = function (t, e, n) {
    if (void 0 === t[e][n]) return [];
    var r = [e];

    for (; e != n;) {
      e = t[e][n], r.push(e);
    }

    return r;
  }, t.floyd_warshall_with_path = function (t, e) {
    e || (e = t.components()[0]);
    var n = J(e.length, e.length),
        o = Array(e.length),
        l = t.directed(),
        i = r(e);

    for (var _t79 = 0; _t79 < e.length; _t79++) {
      n[_t79][_t79] = 0, o[_t79] = Array(e.length);
    }

    var f = function f(e) {
      if (e.source == e.target) return;
      var r = i[e.source.index],
          f = i[e.target.index];
      n[r][f] = t.distance(e), o[r][f] = f, l || (n[f][r] = t.distance(e), o[f][r] = r);
    };

    for (var _n29 = 0; _n29 < e.length; _n29++) {
      t.edges(e[_n29]).forEach(f);
    }

    for (var _t80 = 0; _t80 < e.length; _t80++) {
      for (var _r28 = 0; _r28 < e.length; _r28++) {
        for (var _i13 = 0; _i13 < e.length; _i13++) {
          n[_r28][_i13] > n[_r28][_t80] + n[_t80][_i13] && (n[_r28][_i13] = n[_r28][_t80] + n[_t80][_i13], o[_r28][_i13] = o[_r28][_t80], l || (n[_i13][_r28] = n[_r28][_i13], o[_i13][_r28] = o[_t80][_i13]));
        }
      }
    }

    return [n, o];
  }, t.graph = Pt, t.graph2mat = function (t, e) {
    var n = t.nodes(),
        r = t.links(),
        o = n.length;
    var l;

    if (e || (e = t.directed()), e) {
      var _e33 = o,
          _n30 = o;

      for (var _n31 = o - 1; _n31 >= 0 && 0 === t.inEdges(_n31).length; _n31--) {
        _e33--;
      }

      for (var _e34 = o - 1; _e34 >= 0 && 0 === t.outEdges(_e34).length; _e34--) {
        _n30--;
      }

      l = a(_e33, _n30);

      for (var _t81 = 0; _t81 < r.length; _t81++) {
        var _e35 = r[_t81];
        l[_e35.source.index][_e35.target.index] = _e35.value ? _e35.value : 1;
      }
    } else {
      l = a(o, o);

      for (var _t82 = 0; _t82 < r.length; _t82++) {
        var _e36 = r[_t82];
        l[_e36.source.index][_e36.target.index] = _e36.value ? _e36.value : 1, l[_e36.target.index][_e36.source.index] = _e36.value ? _e36.value : 1;
      }
    }

    return l;
  }, t.graph2valuemats = function (t, e) {
    return e || (e = t.components()), U(t, e).map(Ft);
  }, t.graph_connect = function (t, e) {
    var n = t.links();
    e || (e = t.components());

    for (var _t83 = 0; _t83 < e.length - 1; _t83++) {
      for (var _r29 = _t83 + 1; _r29 < e.length; _r29++) {
        n.push({
          source: e[_t83][0],
          target: e[_r29][0]
        });
      }
    }

    return t.links(n), t.init();
  }, t.graph_empty = St, t.graph_empty_nodes = Rt, t.graph_random = Vt, t.graph_random_erdos_renyi = Qt, t.hcluster = Gt, t.infinities = J, t.intersect_sorted_ints = function (t, e) {
    var n = 0,
        r = 0;
    var o = [];

    for (; n < t.length && r < e.length;) {
      t[n] < e[r] ? n++ : (t[n] > e[r] || (o.push(n), n++), r++);
    }

    return o;
  }, t.inverse_permutation = r, t.laplacian = Yt, t.length = Q, t.mat2graph = function (t, e) {
    var n = t.length,
        r = [],
        o = [];
    var l = Number.NEGATIVE_INFINITY;

    for (var _t84 = 0; _t84 < n; _t84++) {
      r.push({
        id: _t84
      });
    }

    for (var _i14 = 0; _i14 < n; _i14++) {
      var _n32 = t[_i14];

      for (var _t85 = e ? 0 : _i14; _t85 < _n32.length; _t85++) {
        _t85 == r.length && r.push({
          id: _t85
        }), 0 !== _n32[_t85] && (_n32[_t85] > l && (l = _n32[_t85]), o.push({
          source: _i14,
          target: _t85,
          value: _n32[_t85]
        }));
      }
    }

    return Pt(r, o, e).linkDistance(function (t) {
      return 1 + l - t.value;
    }).init();
  }, t.mean = L, t.meancolumns = Ct, t.meantranspose = function (t, e) {
    var n = t.length;
    if (0 === n) return NaN;
    var r = 0,
        o = -1;

    for (; ++o < n;) {
      r += (t[o][e] - r) / (o + 1);
    }

    return r;
  }, t.normalize = V, t.optimal_leaf_order = Ht, t.order = function () {
    var t,
        r = At.euclidean,
        o = Ht,
        l = "complete",
        i = null,
        f = [],
        s = 0,
        a = 0,
        c = 1 / 0;

    function u(u) {
      t = u, c = Math.min(c, u.length);
      var g = a > 0 ? a - 1 : 0,
          d = c < t.length ? c + 1 : c;

      for (var _t86 = f.length - 1; _t86 > 0; _t86 -= 2) {
        var _e37 = f[_t86 - 1],
            _n33 = f[_t86];
        _n33 >= d ? d > c ? (d = Math.min(d, _e37 + 1), f.splice(_t86 - 1, 2)) : _n33 = d : _e37 <= g ? g < a ? (g = Math.max(g, _n33 - 1), f.splice(_t86 - 1, 2)) : _e37 = g : _n33 - _e37 < 3 && f.splice(_t86 - 1, 2);
      }

      try {
        return function (r, o) {
          var l = t;
          if (t = t.slice(r, o), 0 === a && c == t.length) return h();
          s && console.log("i0=".concat(r, " j0=").concat(o));
          null !== i ? (o !== t.length && Nt(i, o, t.length), r > 0 && Nt(i, 0, r)) : v();
          var u = qt(i);

          if (r < a) {
            var _t87 = i[0];

            for (var _e38 = _t87.length; _e38-- > 1;) {
              _t87[_e38] += u;
            }

            for (var _t88 = i.length; _t88-- > 1;) {
              i[_t88][0] += u;
            }

            if (u += u, 0 !== r) for (var _t89 = 0; _t89 < f.length; _t89++) {
              f[_t89] -= r;
            }
          }

          if (o > c) {
            var _t90 = i.length - 1,
                _e39 = i[_t90];

            for (var _n34 = _t90; _n34-- > 0;) {
              _e39[_n34] += u, i[_n34][_t90] += u;
            }
          }

          var g = h();
          r < a ? (0 !== g[0] && g.reverse(), o > c ? _t(0 === g[0] && g[g.length - 1] == g.length - 1, "Invalid constrained permutation endpoints") : _t(0 === g[0], "Invalid constrained permutation start")) : o > c && (g[g.length - 1] !== g.length - 1 && (g = g.reverse()), _t(g[g.length - 1] == g.length - 1, "Invalid constrained permutation end"));
          0 !== r && (g = n(r).concat(g.map(function (t) {
            return t + r;
          })));
          l.length > o && (g = g.concat(e(o, l.length)));
          return g;
        }(g, d);
      } finally {
        r = At.euclidean, o = Ht, l = "complete", i = null, t = null, f = [], a = 0, c = 1 / 0;
      }
    }

    function h() {
      var n, r, o, l, a, c;
      if (0 === f.length) return g();

      for (v(), r = f.length - 1; r > 0; r -= 2) {
        l = f[r - 1], a = f[r], i = Nt(i, l + 1, a - 1), t.splice(l + 1, a - l - 2), s && console.log("Except[".concat(l, ", ").concat(a, "]")), 0 !== i[l][l + 1] && (i[l][l + 1] = i[l + 1][l] = -1);
      }

      for (n = g(), r = 0; r < f.length; r += 2) {
        for (l = f[r], a = f[r + 1], o = 0; o < n.length; o++) {
          n[o] > l ? n[o] += a - l - 2 : n[o] == l && (c = o);
        }

        if (c > 0 && n[c - 1] == a - 1) Array.prototype.splice.apply(n, [c, 0].concat(e(a - 2, l, -1)));else {
          if (n[c + 1] != a - 1) throw "Range not respected";
          Array.prototype.splice.apply(n, [c + 1, 0].concat(e(l + 1, a - 1)));
        }
      }

      return n;
    }

    function g() {
      var e,
          n,
          r,
          f,
          a,
          c,
          u,
          h,
          g = !1;
      var p = [],
          M = {};

      for (v(), a = 0; a < i.length - 1; a++) {
        for (n = i[a], r = [], f = n.indexOf(-1), -1 !== f && (M[a] = [a, f], g = !0), c = n.length; --c > a;) {
          0 === n[c] ? (f = i[c].indexOf(-1), -1 !== f && (M[a] = [c, f], i[f][a] = n[f] = -1, g = !0), r.unshift(c), i = Nt(i, c), t.splice(c, 1)) : n[c] < 0 && (g = !0);
        }

        0 !== r.length && (r.unshift(a), p.push(r));
      }

      if (g) for (a = 0; a < i.length - 1; a++) {
        for (n = i[a], c = a + 1; c < n.length - 1; c++) {
          -1 == i[c][c + 1] && (i[c + 1][c] = i[c][c + 1] = 0);
        }
      }

      for (e = function () {
        s > 1 && yt(i);
        s > 2 && yt(t);
        var e = o().linkage(l).distanceMatrix(i)(t);
        s && console.log("Permutation: ".concat(e));
        return e;
      }(), a = p.length; a-- > 0;) {
        for (r = p[a], c = e.indexOf(r[0]), u = M[r[0]], u && u[0] == r[0] && (c = d(e, c, u[0], u[1], 0), u = void 0), h = 1; h < r.length; h++) {
          e = m(e, c, r[h]), u && u[0] == r[h] && (c = d(e, c, u[0], u[1], h), u = void 0);
        }
      }

      return e;
    }

    function d(t, e, n, r, o) {
      if (e > 0 && t[e - 1] == r) return p(t, e, t.indexOf(n)), e + 1;
      if (t[e + o + 1] == r) return p(t, e + o, t.indexOf(n)), e;
      throw "Index not found";
    }

    function p(t, e, n) {
      if (e == n) return;
      var r = t[e];
      t[e] = t[n], t[n] = r;
    }

    function m(t, e, n) {
      return (t = t.map(function (t) {
        return t < n ? t : t + 1;
      })).splice(e, 0, n), t;
    }

    function v() {
      return null === i && (i = $t().distance(r)(t)), i;
    }

    return u.debug = function (t) {
      return 0 != arguments.length && (s = t), s;
    }, u.distance = function (t) {
      return arguments.length ? (r = t, u) : r;
    }, u.linkage = function (t) {
      return arguments.length ? (l = t, u) : l;
    }, u.limits = function (t, e) {
      return arguments.length ? (a = t, c = e, u) : [a, c];
    }, u.except = function (t) {
      var e;
      if (!arguments.length) return f.slice(0);

      for (e = 1; e < t.length; e++) {
        if (t[e - 1] >= t[e]) throw "Invalid list, indices not sorted";
      }

      return f = t.slice(0), u;
    }, u.orderrowsexcept = function (t, n, l) {
      var i = $t().distance(r)(t);
      var f,
          s,
          a,
          c = !1,
          u = -1;
      i[n][n + 1] = 0, i[n + 1][n] = 0;
      var h = o().distanceMatrix(i)(t);

      for (u = h.indexOf(n), f = 0; f < h.length; f++) {
        s = h[f], s > n && (h[f] += l - n - 2);
      }

      return 0 !== u && h[u - 1] === l - 1 && (c = !0), c && (h.reverse(), u = h.length - u - 1), a = [u + 1, 0].concat(e(n + 1, l - 1)), Array.prototype.splice.apply(h, a), h;
    }, u;
  }, t.parcoords = function (t) {
    t.detectDimensions().autoscale();
    var e = t.data(),
        n = t.types(),
        r = t.hideAxis(),
        o = t.yscale,
        l = [],
        i = [];
    var f = t.dimensions();

    for (var _t91 = 0; _t91 < f.length; _t91++) {
      var _s4 = f[_t91];
      if (r.includes(_s4)) f.splice(_t91, 1), l.push(_s4), _t91--;else if ("number" == n[_s4] || "date" == n[_s4]) {
        var _t92 = [],
            _n35 = o[_s4];

        for (var _r30 = 0; _r30 < e.length; _r30++) {
          _t92.push(_n35(e[_r30][_s4]));
        }

        i.push(_t92);
      } else f.splice(_t91, 1), l.push(_s4), _t91--;
    }

    var _Kt = Kt(i, f),
        _Kt2 = _slicedToArray(_Kt, 2),
        s = _Kt2[0],
        a = _Kt2[1];

    f = s.concat(l.reverse()), t.dimensions(f), t.hideAxis(r);

    for (var _e40 = 0; _e40 < a.length; _e40++) {
      a[_e40] < 0 && t.flip(f[_e40]);
    }
  }, t.parcoords_es = function (t) {
    var e = t.dimensions(),
        n = t.data(),
        r = [],
        o = [],
        l = [];

    for (var _t93 in e) {
      var _i15 = e[_t93];

      if ("number" == _i15.type || "date" == _i15.type) {
        var _e41 = [],
            _r31 = _i15.yscale;

        for (var _o35 = 0; _o35 < n.length; _o35++) {
          _e41.push(_r31(n[_o35][_t93]));
        }

        l.push(_e41), o.push(_t93);
      } else r.push(_t93);
    }

    var _Kt3 = Kt(l, o),
        _Kt4 = _slicedToArray(_Kt3, 2),
        i = _Kt4[0],
        f = _Kt4[1],
        s = i.concat(r.reverse());

    t.xscale.domain(s), t.sortDimensions();

    for (var _e42 = 0; _e42 < f.length; _e42++) {
      f[_e42] < 0 && t.flip(s[_e42]);
    }
  }, t.pca1d = Jt, t.pca_order = function (t, e) {
    return ot(Jt(t, e));
  }, t.pcp = Kt, t.permutation = n, t.permute = Tt, t.permute_inplace = function (t, e) {
    for (var _n36 = 0; _n36 < t.length; _n36++) {
      var _r32 = e[_n36];

      if (_r32 < 0) {
        e[_n36] = -1 - _r32;
        continue;
      }

      var _o36 = _n36;

      for (; _r32 != _n36;) {
        var _n37 = t[_r32];
        t[_r32] = t[_o36], t[_o36] = _n37, _o36 = _r32, _n37 = e[_r32], e[_r32] = -1 - _n37, _r32 = _n37;
      }
    }

    return t;
  }, t.permutetranspose = function (t, e) {
    var n = t.length;

    for (; n-- > 0;) {
      t[n] = Tt(t[n], e);
    }

    return t;
  }, t.poweriteration = jt, t.poweriteration_n = Ot, t.printhcluster = wt, t.printmat = yt, t.printvec = xt, t.randomPermutation = function (t) {
    return zt(n(t));
  }, t.randomPermute = zt, t.random_array = Et, t.random_matrix = function (t, e, n, r) {
    n || (n = e), e != n ? r = !1 : r || (r = !0);
    var o = a(e, n);
    if (r) for (var _n38 = 0; _n38 < e; _n38++) {
      var _r33 = 0;

      for (var _e43 = 0; _e43 < _n38 + 1; _e43++) {
        Math.random() < t && (o[_n38][_e43] = o[_e43][_n38] = 1, _r33++);
      }

      if (0 === _r33) {
        var _t94 = Math.floor(Math.random() * e / 2);

        o[_n38][_t94] = o[_t94][_n38] = 1;
      }
    } else for (var _r34 = 0; _r34 < e; _r34++) {
      var _e44 = 0;

      for (var _l23 = 0; _l23 < n; _l23++) {
        Math.random() < t && (o[_r34][_l23] = 1, _e44++);
      }

      0 === _e44 && (o[_r34][Math.floor(Math.random() * n)] = 1);
    }
    return o;
  }, t.range = e, t.reverse_cuthill_mckee = bt, t.reverse_cuthill_mckee_order = function (t, e) {
    var n,
        r = [];
    e || (e = t.components());

    for (var _o37 = 0; _o37 < e.length; _o37++) {
      n = e[_o37], r = r.concat(bt(t, n));
    }

    return r;
  }, t.set_debug = function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    t.debug = e;
  }, t.sort_order = ot, t.sort_order_ascending = lt, t.sort_order_descending = function (t) {
    return n(0, t.length).sort(function (e, n) {
      return t[n] - t[e];
    });
  }, t.spectral_order = function (t, e) {
    var n = [];
    e || (e = t.components());

    for (var _r35 = 0; _r35 < e.length; _r35++) {
      var _o38 = e[_r35],
          _l24 = ot(Dt(Yt(t, _o38)));

      n = n.concat(Tt(_o38, _l24));
    }

    return n;
  }, t.stablepermute = function (t, e) {
    var n = Tt(t, e);
    return n[0] > n[n.length - 1] && n.reverse(), n;
  }, t.sum = function (t) {
    var e = t.length,
        n = 0;

    for (; e-- > 0;) {
      isNaN(t[e]) || (n += t[e]);
    }

    return n;
  }, t.transpose = G, t.transposeSlice = function (t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t[0].length;
    var r = t.length,
        o = n,
        l = new Array(n - e);
    var i = e - 1;

    for (; ++i < o;) {
      l[i] = new Array(r);

      var _n39 = -1;

      for (; ++_n39 < r;) {
        l[i - e][_n39] = t[_n39][i];
      }
    }

    return l;
  }, t.valuemats_reorder = function (t, e, n) {
    var r = t.map(e);
    return n && (r = r.map(function (t, e) {
      return Tt(n[e], t);
    })), r.reduce(H);
  }, t.variancecovariance = vt, t.version = "2.0.3", t.zeroes = a, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});